unit unit_KontaktAenderung;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Data.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.DB, DB, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.DBCtrls, WEBLib.Grids;

type
  TKontaktAenderung = class(TForm)
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    sourceEinzelkontakt: TDataSource;
    xdsEinzelkontakt: TXDataWebDataSet;
    xdsEinzelkontaktKundennummer: TStringField;
    xdsEinzelkontaktGruppeKunden: TBooleanField;
    xdsEinzelkontaktGruppeLieferanten: TBooleanField;
    xdsEinzelkontaktGruppeSonstige: TBooleanField;
    xdsEinzelkontaktGruppeNichtkunden: TBooleanField;
    xdsEinzelkontaktKontaktgruppe: TStringField;
    xdsEinzelkontaktNachname: TStringField;
    xdsEinzelkontaktVorname: TStringField;
    xdsEinzelkontaktAdresszeile2: TStringField;
    xdsEinzelkontaktAdresszeile3: TStringField;
    xdsEinzelkontaktStrasse: TStringField;
    xdsEinzelkontaktPostleitzahl: TStringField;
    xdsEinzelkontaktOrt: TStringField;
    xdsEinzelkontaktLaenderkuerzel: TStringField;
    xdsEinzelkontaktLand: TStringField;
    xdsEinzelkontaktLaenderkennzeichen: TBooleanField;
    xdsEinzelkontaktAdressanrede: TStringField;
    xdsEinzelkontaktBriefanrede1: TStringField;
    xdsEinzelkontaktBriefanrede2: TStringField;
    xdsEinzelkontaktAdresseBild: TStringField;
    xdsEinzelkontaktLieferanschrift: TStringField;
    xdsEinzelkontaktGeburtsdatum: TDateTimeField;
    xdsEinzelkontaktTelefonNummer: TStringField;
    xdsEinzelkontaktTelefaxNummer: TStringField;
    xdsEinzelkontaktMobilTelefon: TStringField;
    xdsEinzelkontaktEMail: TStringField;
    xdsEinzelkontaktInternet: TStringField;
    xdsEinzelkontaktUmsatzsteuerID: TStringField;
    xdsEinzelkontaktUmsatzsteuerausweis: TBooleanField;
    xdsEinzelkontaktBemerkungen: TStringField;
    xdsEinzelkontaktBranche: TStringField;
    xdsEinzelkontaktSelektiert1: TBooleanField;
    xdsEinzelkontaktSelektiert2: TBooleanField;
    xdsEinzelkontaktSelektiert3: TBooleanField;
    xdsEinzelkontaktZahlungsbedingung: TIntegerField;
    xdsEinzelkontaktTransportbedingung: TStringField;
    xdsEinzelkontaktKilometer: TIntegerField;
    xdsEinzelkontaktRabattsatz: TFloatField;
    xdsEinzelkontaktStundensatz: TFloatField;
    xdsEinzelkontaktKontonummer: TStringField;
    xdsEinzelkontaktBank: TStringField;
    xdsEinzelkontaktBankleitzahl: TFloatField;
    xdsEinzelkontaktKontoinhaber: TStringField;
    xdsEinzelkontaktBetreuer: TStringField;
    xdsEinzelkontaktQuelle: TStringField;
    xdsEinzelkontaktSuchmerkmal: TStringField;
    xdsEinzelkontaktWarenkreditlimit: TFloatField;
    xdsEinzelkontaktWarenkreditgesperrt: TBooleanField;
    xdsEinzelkontaktKundennummerFremd: TStringField;
    xdsEinzelkontaktKeinNewsletter: TBooleanField;
    xdsEinzelkontaktDebitorennummer: TStringField;
    xdsEinzelkontaktKreditorennummer: TStringField;
    xdsEinzelkontaktTelefonAlternativ: TStringField;
    xdsEinzelkontaktKostentraeger: TStringField;
    xdsEinzelkontaktIBAN: TStringField;
    xdsEinzelkontaktBIC: TStringField;
    xdsEinzelkontaktEmailkonto: TStringField;
    xdsEinzelkontaktBenutzername: TStringField;
    xdsEinzelkontaktPasswort: TStringField;
    xdsEinzelkontaktExportOutlook: TBooleanField;
    xdsEinzelkontaktNichtInListeAnzeigen: TBooleanField;
    xdsEinzelkontaktKreditkarteArt: TStringField;
    xdsEinzelkontaktKreditkarteInhaber: TStringField;
    xdsEinzelkontaktKreditkarteNummer: TStringField;
    xdsEinzelkontaktKreditkarteGueltigMonat: TStringField;
    xdsEinzelkontaktKreditkarteGueltigJahr: TIntegerField;
    xdsEinzelkontaktKreditkartePruefziffer: TStringField;
    xdsEinzelkontaktDatumNeu: TDateTimeField;
    xdsEinzelkontaktDatumgeaendert: TDateTimeField;
    xdsEinzelkontaktTitel: TStringField;
    xdsEinzelkontaktStundensatzMontage: TFloatField;
    xdsEinzelkontaktStdMontageU25: TFloatField;
    xdsEinzelkontaktStdMontageU50: TFloatField;
    xdsEinzelkontaktStdMontageU70: TFloatField;
    xdsEinzelkontaktStdMontageU100: TFloatField;
    xdsEinzelkontaktStdMontageU150: TFloatField;
    xdsEinzelkontaktStundensatzWerkstatt: TFloatField;
    xdsEinzelkontaktStdWerkstattU25: TFloatField;
    xdsEinzelkontaktStdWerkstattU50: TFloatField;
    xdsEinzelkontaktStdWerkstattU70: TFloatField;
    xdsEinzelkontaktStdWerkstattU100: TFloatField;
    xdsEinzelkontaktStdWerkstattU150: TFloatField;
    xdsEinzelkontaktArchivReferenz: TStringField;
    xdsEinzelkontaktErloesKontoUST1: TStringField;
    xdsEinzelkontaktErloesKontoUST2: TStringField;
    xdsEinzelkontaktErloesKontoUST3: TStringField;
    xdsEinzelkontaktGebKal: TBooleanField;
    xdsEinzelkontaktEmailversand: TBooleanField;
    xdsEinzelkontaktMahnspesen: TBooleanField;
    xdsEinzelkontaktRechnungSchluss: TStringField;
    xdsEinzelkontaktBenutzerNeu: TStringField;
    xdsEinzelkontaktBenutzerGeaendert: TStringField;
    xdsEinzelkontaktBelegsprache: TStringField;
    xdsEinzelkontaktkmSatz: TFloatField;
    xdsEinzelkontaktKundenklassetext: TStringField;
    xdsEinzelkontaktKundenklasseFarbe: TIntegerField;
    xdsEinzelkontaktAbweichenderRechnungsEmpfaenger: TStringField;
    xdsEinzelkontaktProtokoll: TStringField;
    xdsEinzelkontaktILNTyp1: TStringField;
    xdsEinzelkontaktILNTyp2: TStringField;
    xdsEinzelkontaktKontaktGUID: TStringField;
    xdsEinzelkontaktPLZGUID: TStringField;
    xdsEinzelkontaktPreislistenVariantePakete: TStringField;
    xdsEinzelkontaktSchluesselRechnungslauf: TStringField;
    xdsEinzelkontaktRechnungEmail: TStringField;
    xdsEinzelkontaktZahlungsbedingungEK: TIntegerField;
    xdsEinzelkontaktTransportbedingungEK: TStringField;
    xdsEinzelkontaktRabattsatzEK: TFloatField;
    xdsEinzelkontaktVertreterMatchcode: TStringField;
    xdsEinzelkontaktVertreterProvisionssatz: TFloatField;
    xdsEinzelkontaktUmsatzVKJahr: TFloatField;
    xdsEinzelkontaktUmsatzVKVorjahr: TFloatField;
    xdsEinzelkontaktUmsatzEKJahr: TFloatField;
    xdsEinzelkontaktUmsatzEKVorjahr: TFloatField;
    xdsEinzelkontaktSteuernummer: TStringField;
    xdsEinzelkontaktLoginPW: TStringField;
    xdsEinzelkontaktREperFax: TBooleanField;
    xdsEinzelkontaktErreichbarkeit: TStringField;
    xdsEinzelkontaktErloesKontoUST4: TStringField;
    xdsEinzelkontaktErloesKontoUST5: TStringField;
    xdsEinzelkontaktErloesKontoUST6: TStringField;
    xdsEinzelkontaktBesteuerungKey: TIntegerField;
    xdsEinzelkontaktAuftraegeJahr: TFloatField;
    xdsEinzelkontaktAuftraegeVorjahr: TFloatField;
    xdsEinzelkontaktLieferadresseID: TIntegerField;
    xdsEinzelkontaktUSTIDgeprueft: TDateTimeField;
    xdsEinzelkontaktKontaktverbund: TStringField;
    xdsEinzelkontaktHinweis: TStringField;
    xdsEinzelkontaktLatitude: TFloatField;
    xdsEinzelkontaktLongitude: TFloatField;
    xdsEinzelkontaktkmLuftlinie: TFloatField;
    xdsEinzelkontaktGoogleID: TStringField;
    xdsEinzelkontaktGoogleUpdatedUTC: TDateTimeField;
    xdsEinzelkontaktBundesland: TStringField;
    xdsEinzelkontaktRegion: TStringField;
    xdsEinzelkontaktMandatsreferenz: TStringField;
    xdsEinzelkontaktMandatsreferenzVom: TDateTimeField;
    xdsEinzelkontaktLastschriftArt: TStringField;
    xdsEinzelkontaktMahnsperre: TBooleanField;
    xdsEinzelkontaktSuchbegriff: TStringField;
    xdsEinzelkontaktLieferanschriftDaten: TStringField;
    xdsEinzelkontaktExportKasse: TBooleanField;
    xdsEinzelkontaktLoeschvormerkungDatum: TDateTimeField;
    xdsEinzelkontaktLoeschvormerkungGrund: TStringField;
    xdsEinzelkontaktPseudonymisiert: TStringField;
    xdsEinzelkontaktLoginAktiv: TIntegerField;
    xdsEinzelkontaktSonstigeDaten: TStringField;
    xdsEinzelkontaktB2C: TBooleanField;
    xdsEinzelkontaktTIN: TStringField;
    xdsEinzelkontaktMindestbestellwert: TFloatField;
    TC: TTableControl;
    edtStrasse: TDBEdit;
    edtPostleitzahl: TDBEdit;
    btnzurueck: TButton;
    btnSpeichern: TButton;
    edtVorname: TDBEdit;
    edtAdresszeile2: TDBEdit;
    edtAdresszeile3: TDBEdit;
    edtOrt: TDBEdit;
    xdsLaender: TXDataWebDataSet;
    sourceLaender: TDataSource;
    xdsLaenderLaenderkuerzel: TStringField;
    xdsLaenderLand: TStringField;
    edtLand: TDBLookupComboBox;
    edtTelefon: TDBEdit;
    edtTelefonAlternativ: TDBEdit;
    edtTelefonMobil: TDBEdit;
    edtInternet: TDBEdit;
    edtEmail: TDBEdit;
    xdsBestKey: TXDataWebDataSet;
    sourceBestKey: TDataSource;
    xdsBestKeyBesteuerungKey: TIntegerField;
    xdsBestKeyBesteuerungKurzText: TStringField;
    xdsBestKeyBesteuerungLangText: TStringField;
    xdsBestKeyUmsatzsteuerausweis: TBooleanField;
    xdsBestKeyKtoVorsteuerSatz1: TIntegerField;
    xdsBestKeyKtoVorsteuerSatz2: TIntegerField;
    xdsBestKeyKtoVorsteuerSatz3: TIntegerField;
    xdsBestKeyKtoVorsteuerSatz4: TIntegerField;
    xdsBestKeyKtoVorsteuerSatz5: TIntegerField;
    xdsBestKeyKtoVorsteuerSatz6: TIntegerField;
    xdsBestKeyKtoErloeseSatz1: TIntegerField;
    xdsBestKeyKtoErloeseSatz2: TIntegerField;
    xdsBestKeyKtoErloeseSatz3: TIntegerField;
    xdsBestKeyKtoErloeseSatz4: TIntegerField;
    xdsBestKeyKtoErloeseSatz5: TIntegerField;
    xdsBestKeyKtoErloeseSatz6: TIntegerField;
    xdsBestKeyKtoSkontoaufwandSatz1: TIntegerField;
    xdsBestKeyKtoSkontoaufwandSatz2: TIntegerField;
    xdsBestKeyKtoSkontoaufwandSatz3: TIntegerField;
    xdsBestKeyKtoSkontoaufwandSatz4: TIntegerField;
    xdsBestKeyKtoSkontoaufwandSatz5: TIntegerField;
    xdsBestKeyKtoSkontoaufwandSatz6: TIntegerField;
    xdsBestKeyKtoSkontoertragSatz1: TIntegerField;
    xdsBestKeyKtoSkontoertragSatz2: TIntegerField;
    xdsBestKeyKtoSkontoertragSatz3: TIntegerField;
    xdsBestKeyKtoSkontoertragSatz4: TIntegerField;
    xdsBestKeyKtoSkontoertragSatz5: TIntegerField;
    xdsBestKeyKtoSkontoertragSatz6: TIntegerField;
    xdsBestKeyKtoErloesschmaelerungenSatz1: TIntegerField;
    xdsBestKeyKtoErloesschmaelerungenSatz2: TIntegerField;
    xdsBestKeyKtoErloesschmaelerungenSatz3: TIntegerField;
    xdsBestKeyKtoErloesschmaelerungenSatz4: TIntegerField;
    xdsBestKeyKtoErloesschmaelerungenSatz5: TIntegerField;
    xdsBestKeyKtoErloesschmaelerungenSatz6: TIntegerField;
    xdsBestKeyNatura: TStringField;
    xdsBestKeyBSchl_UST_Satz1: TIntegerField;
    xdsBestKeyBSchl_UST_Satz2: TIntegerField;
    xdsBestKeyBSchl_UST_Satz3: TIntegerField;
    xdsBestKeyBSchl_UST_Satz4: TIntegerField;
    xdsBestKeyBSchl_UST_Satz5: TIntegerField;
    xdsBestKeyBSchl_UST_Satz6: TIntegerField;
    xdsBestKeyBSchl_Vorsteuer_Satz1: TIntegerField;
    xdsBestKeyBSchl_Vorsteuer_Satz2: TIntegerField;
    xdsBestKeyBSchl_Vorsteuer_Satz3: TIntegerField;
    xdsBestKeyBSchl_Vorsteuer_Satz4: TIntegerField;
    xdsBestKeyBSchl_Vorsteuer_Satz5: TIntegerField;
    xdsBestKeyBSchl_Vorsteuer_Satz6: TIntegerField;
    xdsBestKeyDokTyp: TStringField;
    edtAdressanrede: TDBEdit;
    edtTitel: TDBEdit;
    edtNachname: TDBEdit;
    procedure WebFormShow(Sender: TObject);
    procedure btnzurueckClick(Sender: TObject);
    procedure xdsLaenderAfterOpen(DataSet: TDataSet);
    procedure xdsEinzelkontaktAfterOpen(DataSet: TDataSet);
    procedure sourceEinzelkontaktStateChange(Sender: TObject);
    procedure btnSpeichernClick(Sender: TObject);
    procedure xdsBestKeyAfterOpen(DataSet: TDataSet);
    procedure xdsEinzelkontaktBeforePost(DataSet: TDataSet);
    procedure xdsEinzelkontaktAfterPost(DataSet: TDataSet);
    procedure xdsEinzelkontaktAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    AEKundennummer:string;
  protected procedure LoadDFMValues; override; end;

var
  KontaktAenderung: TKontaktAenderung;

implementation
  uses unit1, unit2;
{$R *.dfm}

procedure TKontaktAenderung.btnSpeichernClick(Sender: TObject);
begin
  if xdslaender.Locate('Land', xdsEinzelkontaktLand.asstring,[])=true then
  begin
    xdsEinzelkontaktLaenderkuerzel.asstring:=xdsLaenderLaenderkuerzel.asstring;
    if xdsEinzelkontaktLaenderkuerzel.asstring<>dm2.tableSYSDATLaenderkuerzel.asstring then xdsEinzelkontaktLaenderkennzeichen.asboolean:=true else xdsEinzelkontaktLaenderkennzeichen.asboolean:=false;
    xdsEinzelkontakt.post;
  end
  else
  begin
    showmessage('Sie haben noch kein Land ausgewählt, Vorgang wird abgebrochen');
    exit;
  end;
end;

procedure TKontaktAenderung.btnzurueckClick(Sender: TObject);
begin
  xdsEinzelkontakt.Close;
  self.Close;
end;

procedure TKontaktAenderung.sourceEinzelkontaktStateChange(Sender: TObject);
begin
  if sourceEinzelkontakt.state<>dsBrowse then btnSpeichern.enabled:=true else btnspeichern.Enabled:=false;

end;

procedure TKontaktAenderung.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
  i:integer;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Kontakt bearbeiten '+AEKundennummer+'</h5></nav>';
  myelement:=container1.ElementHandle;
  container2.ParentElement:=myelement;
  container3.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  btnzurueck.ParentElement:=myelement;


  myelement:=container2.ElementHandle;
  tc.ParentElement:=myElement;
  TC.Visible:=true;
  TC.RowCount:=17;
  TC.ColCount:=2;
  i:=0;
  TC.Cells[0,i]:='Nachname';
  myelement:=TC.CellElements[1,i];
  edtNachname.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Adressanrede';
  myelement:=TC.CellElements[1,i];
  edtAdressanrede.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Titel';
  myelement:=TC.CellElements[1,i];
  edttitel.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Vorname';
  myelement:=TC.CellElements[1,i];
  edtVorname.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Adresszeile2';
  myelement:=TC.CellElements[1,i];
  edtAdresszeile2.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Adresszeile3';
  myelement:=TC.CellElements[1,i];
  edtAdresszeile3.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Strasse';
  myelement:=TC.CellElements[1,i];
  edtStrasse.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Postleizahl';
  myelement:=TC.CellElements[1,i];
  edtPostleitzahl.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Ort';
  myelement:=TC.CellElements[1,i];
  edtOrt.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Land';
  myelement:=TC.CellElements[1,i];
  edtLand.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Telefon';
  myelement:=TC.CellElements[1,i];
  edtTelefon.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Telefon Alternativ';
  myelement:=TC.CellElements[1,i];
  edtTelefonAlternativ.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Mobiltelefon';
  myelement:=TC.CellElements[1,i];
  edtTelefonMobil.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Internet';
  myelement:=TC.CellElements[1,i];
  edtInternet.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Email';
  myelement:=TC.CellElements[1,i];
  edtEmail.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='';
  myelement:=TC.CellElements[1,i];
  btnSpeichern.ParentElement:=myelement;
  dm2.tableSYSDAT.load;
  xdsBestKey.load;

end;

procedure TKontaktAenderung.xdsBestKeyAfterOpen(DataSet: TDataSet);
begin
  xdsLaender.load;

end;

procedure TKontaktAenderung.xdsEinzelkontaktAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  if info.Records[0].Error='' then
  begin
    xdsBestKey.Close;
    xdsLaender.close;;
    xdsEinzelkontakt.close;
    close;
  end;
end;

procedure TKontaktAenderung.xdsEinzelkontaktAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;

begin

end;

procedure TKontaktAenderung.xdsEinzelkontaktAfterPost(DataSet: TDataSet);
begin
  xdsEinzelkontakt.ApplyUpdates;
end;

procedure TKontaktAenderung.xdsEinzelkontaktBeforePost(DataSet: TDataSet);
var
  adrbild:string;
begin
  adrbild:='';
  if length(xdsEinzelkontaktadressanrede.asstring)>1 then
  begin
    adrbild:=adrbild + xdsEinzelkontaktadressanrede.asstring+chr(13)+chr(10);
  end;
  if (length(xdsEinzelkontakttitel.asstring)>1) then
  begin
    adrbild:=adrbild + xdsEinzelkontakttitel.asstring+' ';
  end;
  if length(xdsEinzelkontaktvorname.asstring)>1 then
  begin
    adrbild:=adrbild + xdsEinzelkontaktvorname.asstring+' ';
  end;
  adrbild:=adrbild + xdsEinzelkontaktnachname.asstring+chr(13)+chr(10);
  if length(xdsEinzelkontaktAdresszeile2.asstring)>0 then
  begin
    adrbild:=adrbild + xdsEinzelkontaktadresszeile2.asstring+chr(13)+chr(10);
  end;
  if length(xdsEinzelkontaktAdresszeile3.asstring)>0 then
  begin
    adrbild:=adrbild + xdsEinzelkontaktadresszeile3.asstring+chr(13)+chr(10);
  end;
  adrbild:=adrbild + xdsEinzelkontaktStrasse.asstring+chr(13)+chr(10);
  if xdsEinzelkontaktLaenderkennzeichen.asboolean=true then
  begin
    adrbild:=adrbild + xdsEinzelkontaktpostleitzahl.asstring+ ' ';
    adrbild:=adrbild + uppercase(xdsEinzelkontaktort.asstring)+chr(13)+chr(10);
    adrbild:=adrbild + uppercase(xdsEinzelkontaktland.asstring);
  end
  else
  begin
    adrbild:=adrbild +xdsEinzelkontaktpostleitzahl.asstring+ ' ';
    adrbild:=adrbild + xdsEinzelkontaktort.asstring+chr(13)+chr(10);
  end;
  xdsEinzelkontaktAdresseBild.asstring:=adrbild;

  if xdsbestkey.Locate('BesteuerungKey',xdsEinzelkontaktBesteuerungKey.AsString,[])=true then
  begin
    xdsEinzelkontaktumsatzsteuerausweis.AsBoolean:=xdsbestkeyUmsatzsteuerausweis.AsBoolean;
    xdsEinzelkontaktErloesKontoUST1.AsString:=xdsBestKeyKtoErloeseSatz1.asstring;
    xdsEinzelkontaktErloesKontoUST2.AsString:=xdsBestKeyKtoErloeseSatz2.asstring;
    xdsEinzelkontaktErloesKontoUST3.AsString:=xdsBestKeyKtoErloeseSatz3.asstring;
    xdsEinzelkontaktErloesKontoUST4.AsString:=xdsBestKeyKtoErloeseSatz4.asstring;
    xdsEinzelkontaktErloesKontoUST5.AsString:=xdsBestKeyKtoErloeseSatz5.asstring;
    xdsEinzelkontaktErloesKontoUST6.AsString:=xdsBestKeyKtoErloeseSatz6.asstring;
  end;
  xdsEinzelkontaktprotokoll.asstring:=xdsEinzelkontaktprotokoll.asstring+datetimetostr(date+time)+' CADIAWEB '+ BenutzerLoginName+#13+#10;
  xdsEinzelkontaktDatumgeaendert.asdatetime:=date+time;
end;

procedure TKontaktAenderung.xdsLaenderAfterOpen(DataSet: TDataSet);
begin
  xdsEinzelkontakt.Close;
  xdseinzelkontakt.QueryString:='$filter=Kundennummer eq '+quotedstr(AEKundennummer);
  xdseinzelkontakt.Load;
end;

procedure TKontaktAenderung.LoadDFMValues;
begin
  inherited LoadDFMValues;

  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  TC := TTableControl.Create(Self);
  edtStrasse := TDBEdit.Create(Self);
  edtPostleitzahl := TDBEdit.Create(Self);
  btnzurueck := TButton.Create(Self);
  btnSpeichern := TButton.Create(Self);
  edtVorname := TDBEdit.Create(Self);
  edtAdresszeile2 := TDBEdit.Create(Self);
  edtAdresszeile3 := TDBEdit.Create(Self);
  edtOrt := TDBEdit.Create(Self);
  edtLand := TDBLookupComboBox.Create(Self);
  edtTelefon := TDBEdit.Create(Self);
  edtTelefonAlternativ := TDBEdit.Create(Self);
  edtTelefonMobil := TDBEdit.Create(Self);
  edtInternet := TDBEdit.Create(Self);
  edtEmail := TDBEdit.Create(Self);
  edtAdressanrede := TDBEdit.Create(Self);
  edtTitel := TDBEdit.Create(Self);
  edtNachname := TDBEdit.Create(Self);
  sourceEinzelkontakt := TDataSource.Create(Self);
  xdsEinzelkontakt := TXDataWebDataSet.Create(Self);
  xdsEinzelkontaktKundennummer := TStringField.Create(Self);
  xdsEinzelkontaktGruppeKunden := TBooleanField.Create(Self);
  xdsEinzelkontaktGruppeLieferanten := TBooleanField.Create(Self);
  xdsEinzelkontaktGruppeSonstige := TBooleanField.Create(Self);
  xdsEinzelkontaktGruppeNichtkunden := TBooleanField.Create(Self);
  xdsEinzelkontaktKontaktgruppe := TStringField.Create(Self);
  xdsEinzelkontaktNachname := TStringField.Create(Self);
  xdsEinzelkontaktVorname := TStringField.Create(Self);
  xdsEinzelkontaktAdresszeile2 := TStringField.Create(Self);
  xdsEinzelkontaktAdresszeile3 := TStringField.Create(Self);
  xdsEinzelkontaktStrasse := TStringField.Create(Self);
  xdsEinzelkontaktPostleitzahl := TStringField.Create(Self);
  xdsEinzelkontaktOrt := TStringField.Create(Self);
  xdsEinzelkontaktLaenderkuerzel := TStringField.Create(Self);
  xdsEinzelkontaktLand := TStringField.Create(Self);
  xdsEinzelkontaktLaenderkennzeichen := TBooleanField.Create(Self);
  xdsEinzelkontaktAdressanrede := TStringField.Create(Self);
  xdsEinzelkontaktBriefanrede1 := TStringField.Create(Self);
  xdsEinzelkontaktBriefanrede2 := TStringField.Create(Self);
  xdsEinzelkontaktAdresseBild := TStringField.Create(Self);
  xdsEinzelkontaktLieferanschrift := TStringField.Create(Self);
  xdsEinzelkontaktGeburtsdatum := TDateTimeField.Create(Self);
  xdsEinzelkontaktTelefonNummer := TStringField.Create(Self);
  xdsEinzelkontaktTelefaxNummer := TStringField.Create(Self);
  xdsEinzelkontaktMobilTelefon := TStringField.Create(Self);
  xdsEinzelkontaktEMail := TStringField.Create(Self);
  xdsEinzelkontaktInternet := TStringField.Create(Self);
  xdsEinzelkontaktUmsatzsteuerID := TStringField.Create(Self);
  xdsEinzelkontaktUmsatzsteuerausweis := TBooleanField.Create(Self);
  xdsEinzelkontaktBemerkungen := TStringField.Create(Self);
  xdsEinzelkontaktBranche := TStringField.Create(Self);
  xdsEinzelkontaktSelektiert1 := TBooleanField.Create(Self);
  xdsEinzelkontaktSelektiert2 := TBooleanField.Create(Self);
  xdsEinzelkontaktSelektiert3 := TBooleanField.Create(Self);
  xdsEinzelkontaktZahlungsbedingung := TIntegerField.Create(Self);
  xdsEinzelkontaktTransportbedingung := TStringField.Create(Self);
  xdsEinzelkontaktKilometer := TIntegerField.Create(Self);
  xdsEinzelkontaktRabattsatz := TFloatField.Create(Self);
  xdsEinzelkontaktStundensatz := TFloatField.Create(Self);
  xdsEinzelkontaktKontonummer := TStringField.Create(Self);
  xdsEinzelkontaktBank := TStringField.Create(Self);
  xdsEinzelkontaktBankleitzahl := TFloatField.Create(Self);
  xdsEinzelkontaktKontoinhaber := TStringField.Create(Self);
  xdsEinzelkontaktBetreuer := TStringField.Create(Self);
  xdsEinzelkontaktQuelle := TStringField.Create(Self);
  xdsEinzelkontaktSuchmerkmal := TStringField.Create(Self);
  xdsEinzelkontaktWarenkreditlimit := TFloatField.Create(Self);
  xdsEinzelkontaktWarenkreditgesperrt := TBooleanField.Create(Self);
  xdsEinzelkontaktKundennummerFremd := TStringField.Create(Self);
  xdsEinzelkontaktKeinNewsletter := TBooleanField.Create(Self);
  xdsEinzelkontaktDebitorennummer := TStringField.Create(Self);
  xdsEinzelkontaktKreditorennummer := TStringField.Create(Self);
  xdsEinzelkontaktTelefonAlternativ := TStringField.Create(Self);
  xdsEinzelkontaktKostentraeger := TStringField.Create(Self);
  xdsEinzelkontaktIBAN := TStringField.Create(Self);
  xdsEinzelkontaktBIC := TStringField.Create(Self);
  xdsEinzelkontaktEmailkonto := TStringField.Create(Self);
  xdsEinzelkontaktBenutzername := TStringField.Create(Self);
  xdsEinzelkontaktPasswort := TStringField.Create(Self);
  xdsEinzelkontaktExportOutlook := TBooleanField.Create(Self);
  xdsEinzelkontaktNichtInListeAnzeigen := TBooleanField.Create(Self);
  xdsEinzelkontaktKreditkarteArt := TStringField.Create(Self);
  xdsEinzelkontaktKreditkarteInhaber := TStringField.Create(Self);
  xdsEinzelkontaktKreditkarteNummer := TStringField.Create(Self);
  xdsEinzelkontaktKreditkarteGueltigMonat := TStringField.Create(Self);
  xdsEinzelkontaktKreditkarteGueltigJahr := TIntegerField.Create(Self);
  xdsEinzelkontaktKreditkartePruefziffer := TStringField.Create(Self);
  xdsEinzelkontaktDatumNeu := TDateTimeField.Create(Self);
  xdsEinzelkontaktDatumgeaendert := TDateTimeField.Create(Self);
  xdsEinzelkontaktTitel := TStringField.Create(Self);
  xdsEinzelkontaktStundensatzMontage := TFloatField.Create(Self);
  xdsEinzelkontaktStdMontageU25 := TFloatField.Create(Self);
  xdsEinzelkontaktStdMontageU50 := TFloatField.Create(Self);
  xdsEinzelkontaktStdMontageU70 := TFloatField.Create(Self);
  xdsEinzelkontaktStdMontageU100 := TFloatField.Create(Self);
  xdsEinzelkontaktStdMontageU150 := TFloatField.Create(Self);
  xdsEinzelkontaktStundensatzWerkstatt := TFloatField.Create(Self);
  xdsEinzelkontaktStdWerkstattU25 := TFloatField.Create(Self);
  xdsEinzelkontaktStdWerkstattU50 := TFloatField.Create(Self);
  xdsEinzelkontaktStdWerkstattU70 := TFloatField.Create(Self);
  xdsEinzelkontaktStdWerkstattU100 := TFloatField.Create(Self);
  xdsEinzelkontaktStdWerkstattU150 := TFloatField.Create(Self);
  xdsEinzelkontaktArchivReferenz := TStringField.Create(Self);
  xdsEinzelkontaktErloesKontoUST1 := TStringField.Create(Self);
  xdsEinzelkontaktErloesKontoUST2 := TStringField.Create(Self);
  xdsEinzelkontaktErloesKontoUST3 := TStringField.Create(Self);
  xdsEinzelkontaktGebKal := TBooleanField.Create(Self);
  xdsEinzelkontaktEmailversand := TBooleanField.Create(Self);
  xdsEinzelkontaktMahnspesen := TBooleanField.Create(Self);
  xdsEinzelkontaktRechnungSchluss := TStringField.Create(Self);
  xdsEinzelkontaktBenutzerNeu := TStringField.Create(Self);
  xdsEinzelkontaktBenutzerGeaendert := TStringField.Create(Self);
  xdsEinzelkontaktBelegsprache := TStringField.Create(Self);
  xdsEinzelkontaktkmSatz := TFloatField.Create(Self);
  xdsEinzelkontaktKundenklassetext := TStringField.Create(Self);
  xdsEinzelkontaktKundenklasseFarbe := TIntegerField.Create(Self);
  xdsEinzelkontaktAbweichenderRechnungsEmpfaenger := TStringField.Create(Self);
  xdsEinzelkontaktProtokoll := TStringField.Create(Self);
  xdsEinzelkontaktILNTyp1 := TStringField.Create(Self);
  xdsEinzelkontaktILNTyp2 := TStringField.Create(Self);
  xdsEinzelkontaktKontaktGUID := TStringField.Create(Self);
  xdsEinzelkontaktPLZGUID := TStringField.Create(Self);
  xdsEinzelkontaktPreislistenVariantePakete := TStringField.Create(Self);
  xdsEinzelkontaktSchluesselRechnungslauf := TStringField.Create(Self);
  xdsEinzelkontaktRechnungEmail := TStringField.Create(Self);
  xdsEinzelkontaktZahlungsbedingungEK := TIntegerField.Create(Self);
  xdsEinzelkontaktTransportbedingungEK := TStringField.Create(Self);
  xdsEinzelkontaktRabattsatzEK := TFloatField.Create(Self);
  xdsEinzelkontaktVertreterMatchcode := TStringField.Create(Self);
  xdsEinzelkontaktVertreterProvisionssatz := TFloatField.Create(Self);
  xdsEinzelkontaktUmsatzVKJahr := TFloatField.Create(Self);
  xdsEinzelkontaktUmsatzVKVorjahr := TFloatField.Create(Self);
  xdsEinzelkontaktUmsatzEKJahr := TFloatField.Create(Self);
  xdsEinzelkontaktUmsatzEKVorjahr := TFloatField.Create(Self);
  xdsEinzelkontaktSteuernummer := TStringField.Create(Self);
  xdsEinzelkontaktLoginPW := TStringField.Create(Self);
  xdsEinzelkontaktREperFax := TBooleanField.Create(Self);
  xdsEinzelkontaktErreichbarkeit := TStringField.Create(Self);
  xdsEinzelkontaktErloesKontoUST4 := TStringField.Create(Self);
  xdsEinzelkontaktErloesKontoUST5 := TStringField.Create(Self);
  xdsEinzelkontaktErloesKontoUST6 := TStringField.Create(Self);
  xdsEinzelkontaktBesteuerungKey := TIntegerField.Create(Self);
  xdsEinzelkontaktAuftraegeJahr := TFloatField.Create(Self);
  xdsEinzelkontaktAuftraegeVorjahr := TFloatField.Create(Self);
  xdsEinzelkontaktLieferadresseID := TIntegerField.Create(Self);
  xdsEinzelkontaktUSTIDgeprueft := TDateTimeField.Create(Self);
  xdsEinzelkontaktKontaktverbund := TStringField.Create(Self);
  xdsEinzelkontaktHinweis := TStringField.Create(Self);
  xdsEinzelkontaktLatitude := TFloatField.Create(Self);
  xdsEinzelkontaktLongitude := TFloatField.Create(Self);
  xdsEinzelkontaktkmLuftlinie := TFloatField.Create(Self);
  xdsEinzelkontaktGoogleID := TStringField.Create(Self);
  xdsEinzelkontaktGoogleUpdatedUTC := TDateTimeField.Create(Self);
  xdsEinzelkontaktBundesland := TStringField.Create(Self);
  xdsEinzelkontaktRegion := TStringField.Create(Self);
  xdsEinzelkontaktMandatsreferenz := TStringField.Create(Self);
  xdsEinzelkontaktMandatsreferenzVom := TDateTimeField.Create(Self);
  xdsEinzelkontaktLastschriftArt := TStringField.Create(Self);
  xdsEinzelkontaktMahnsperre := TBooleanField.Create(Self);
  xdsEinzelkontaktSuchbegriff := TStringField.Create(Self);
  xdsEinzelkontaktLieferanschriftDaten := TStringField.Create(Self);
  xdsEinzelkontaktExportKasse := TBooleanField.Create(Self);
  xdsEinzelkontaktLoeschvormerkungDatum := TDateTimeField.Create(Self);
  xdsEinzelkontaktLoeschvormerkungGrund := TStringField.Create(Self);
  xdsEinzelkontaktPseudonymisiert := TStringField.Create(Self);
  xdsEinzelkontaktLoginAktiv := TIntegerField.Create(Self);
  xdsEinzelkontaktSonstigeDaten := TStringField.Create(Self);
  xdsEinzelkontaktB2C := TBooleanField.Create(Self);
  xdsEinzelkontaktTIN := TStringField.Create(Self);
  xdsEinzelkontaktMindestbestellwert := TFloatField.Create(Self);
  xdsLaender := TXDataWebDataSet.Create(Self);
  xdsLaenderLaenderkuerzel := TStringField.Create(Self);
  xdsLaenderLand := TStringField.Create(Self);
  sourceLaender := TDataSource.Create(Self);
  xdsBestKey := TXDataWebDataSet.Create(Self);
  xdsBestKeyBesteuerungKey := TIntegerField.Create(Self);
  xdsBestKeyBesteuerungKurzText := TStringField.Create(Self);
  xdsBestKeyBesteuerungLangText := TStringField.Create(Self);
  xdsBestKeyUmsatzsteuerausweis := TBooleanField.Create(Self);
  xdsBestKeyKtoVorsteuerSatz1 := TIntegerField.Create(Self);
  xdsBestKeyKtoVorsteuerSatz2 := TIntegerField.Create(Self);
  xdsBestKeyKtoVorsteuerSatz3 := TIntegerField.Create(Self);
  xdsBestKeyKtoVorsteuerSatz4 := TIntegerField.Create(Self);
  xdsBestKeyKtoVorsteuerSatz5 := TIntegerField.Create(Self);
  xdsBestKeyKtoVorsteuerSatz6 := TIntegerField.Create(Self);
  xdsBestKeyKtoErloeseSatz1 := TIntegerField.Create(Self);
  xdsBestKeyKtoErloeseSatz2 := TIntegerField.Create(Self);
  xdsBestKeyKtoErloeseSatz3 := TIntegerField.Create(Self);
  xdsBestKeyKtoErloeseSatz4 := TIntegerField.Create(Self);
  xdsBestKeyKtoErloeseSatz5 := TIntegerField.Create(Self);
  xdsBestKeyKtoErloeseSatz6 := TIntegerField.Create(Self);
  xdsBestKeyKtoSkontoaufwandSatz1 := TIntegerField.Create(Self);
  xdsBestKeyKtoSkontoaufwandSatz2 := TIntegerField.Create(Self);
  xdsBestKeyKtoSkontoaufwandSatz3 := TIntegerField.Create(Self);
  xdsBestKeyKtoSkontoaufwandSatz4 := TIntegerField.Create(Self);
  xdsBestKeyKtoSkontoaufwandSatz5 := TIntegerField.Create(Self);
  xdsBestKeyKtoSkontoaufwandSatz6 := TIntegerField.Create(Self);
  xdsBestKeyKtoSkontoertragSatz1 := TIntegerField.Create(Self);
  xdsBestKeyKtoSkontoertragSatz2 := TIntegerField.Create(Self);
  xdsBestKeyKtoSkontoertragSatz3 := TIntegerField.Create(Self);
  xdsBestKeyKtoSkontoertragSatz4 := TIntegerField.Create(Self);
  xdsBestKeyKtoSkontoertragSatz5 := TIntegerField.Create(Self);
  xdsBestKeyKtoSkontoertragSatz6 := TIntegerField.Create(Self);
  xdsBestKeyKtoErloesschmaelerungenSatz1 := TIntegerField.Create(Self);
  xdsBestKeyKtoErloesschmaelerungenSatz2 := TIntegerField.Create(Self);
  xdsBestKeyKtoErloesschmaelerungenSatz3 := TIntegerField.Create(Self);
  xdsBestKeyKtoErloesschmaelerungenSatz4 := TIntegerField.Create(Self);
  xdsBestKeyKtoErloesschmaelerungenSatz5 := TIntegerField.Create(Self);
  xdsBestKeyKtoErloesschmaelerungenSatz6 := TIntegerField.Create(Self);
  xdsBestKeyNatura := TStringField.Create(Self);
  xdsBestKeyBSchl_UST_Satz1 := TIntegerField.Create(Self);
  xdsBestKeyBSchl_UST_Satz2 := TIntegerField.Create(Self);
  xdsBestKeyBSchl_UST_Satz3 := TIntegerField.Create(Self);
  xdsBestKeyBSchl_UST_Satz4 := TIntegerField.Create(Self);
  xdsBestKeyBSchl_UST_Satz5 := TIntegerField.Create(Self);
  xdsBestKeyBSchl_UST_Satz6 := TIntegerField.Create(Self);
  xdsBestKeyBSchl_Vorsteuer_Satz1 := TIntegerField.Create(Self);
  xdsBestKeyBSchl_Vorsteuer_Satz2 := TIntegerField.Create(Self);
  xdsBestKeyBSchl_Vorsteuer_Satz3 := TIntegerField.Create(Self);
  xdsBestKeyBSchl_Vorsteuer_Satz4 := TIntegerField.Create(Self);
  xdsBestKeyBSchl_Vorsteuer_Satz5 := TIntegerField.Create(Self);
  xdsBestKeyBSchl_Vorsteuer_Satz6 := TIntegerField.Create(Self);
  xdsBestKeyDokTyp := TStringField.Create(Self);
  sourceBestKey := TDataSource.Create(Self);

  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  TC.BeforeLoadDFMValues;
  edtStrasse.BeforeLoadDFMValues;
  edtPostleitzahl.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  btnSpeichern.BeforeLoadDFMValues;
  edtVorname.BeforeLoadDFMValues;
  edtAdresszeile2.BeforeLoadDFMValues;
  edtAdresszeile3.BeforeLoadDFMValues;
  edtOrt.BeforeLoadDFMValues;
  edtLand.BeforeLoadDFMValues;
  edtTelefon.BeforeLoadDFMValues;
  edtTelefonAlternativ.BeforeLoadDFMValues;
  edtTelefonMobil.BeforeLoadDFMValues;
  edtInternet.BeforeLoadDFMValues;
  edtEmail.BeforeLoadDFMValues;
  edtAdressanrede.BeforeLoadDFMValues;
  edtTitel.BeforeLoadDFMValues;
  edtNachname.BeforeLoadDFMValues;
  sourceEinzelkontakt.BeforeLoadDFMValues;
  xdsEinzelkontakt.BeforeLoadDFMValues;
  xdsEinzelkontaktKundennummer.BeforeLoadDFMValues;
  xdsEinzelkontaktGruppeKunden.BeforeLoadDFMValues;
  xdsEinzelkontaktGruppeLieferanten.BeforeLoadDFMValues;
  xdsEinzelkontaktGruppeSonstige.BeforeLoadDFMValues;
  xdsEinzelkontaktGruppeNichtkunden.BeforeLoadDFMValues;
  xdsEinzelkontaktKontaktgruppe.BeforeLoadDFMValues;
  xdsEinzelkontaktNachname.BeforeLoadDFMValues;
  xdsEinzelkontaktVorname.BeforeLoadDFMValues;
  xdsEinzelkontaktAdresszeile2.BeforeLoadDFMValues;
  xdsEinzelkontaktAdresszeile3.BeforeLoadDFMValues;
  xdsEinzelkontaktStrasse.BeforeLoadDFMValues;
  xdsEinzelkontaktPostleitzahl.BeforeLoadDFMValues;
  xdsEinzelkontaktOrt.BeforeLoadDFMValues;
  xdsEinzelkontaktLaenderkuerzel.BeforeLoadDFMValues;
  xdsEinzelkontaktLand.BeforeLoadDFMValues;
  xdsEinzelkontaktLaenderkennzeichen.BeforeLoadDFMValues;
  xdsEinzelkontaktAdressanrede.BeforeLoadDFMValues;
  xdsEinzelkontaktBriefanrede1.BeforeLoadDFMValues;
  xdsEinzelkontaktBriefanrede2.BeforeLoadDFMValues;
  xdsEinzelkontaktAdresseBild.BeforeLoadDFMValues;
  xdsEinzelkontaktLieferanschrift.BeforeLoadDFMValues;
  xdsEinzelkontaktGeburtsdatum.BeforeLoadDFMValues;
  xdsEinzelkontaktTelefonNummer.BeforeLoadDFMValues;
  xdsEinzelkontaktTelefaxNummer.BeforeLoadDFMValues;
  xdsEinzelkontaktMobilTelefon.BeforeLoadDFMValues;
  xdsEinzelkontaktEMail.BeforeLoadDFMValues;
  xdsEinzelkontaktInternet.BeforeLoadDFMValues;
  xdsEinzelkontaktUmsatzsteuerID.BeforeLoadDFMValues;
  xdsEinzelkontaktUmsatzsteuerausweis.BeforeLoadDFMValues;
  xdsEinzelkontaktBemerkungen.BeforeLoadDFMValues;
  xdsEinzelkontaktBranche.BeforeLoadDFMValues;
  xdsEinzelkontaktSelektiert1.BeforeLoadDFMValues;
  xdsEinzelkontaktSelektiert2.BeforeLoadDFMValues;
  xdsEinzelkontaktSelektiert3.BeforeLoadDFMValues;
  xdsEinzelkontaktZahlungsbedingung.BeforeLoadDFMValues;
  xdsEinzelkontaktTransportbedingung.BeforeLoadDFMValues;
  xdsEinzelkontaktKilometer.BeforeLoadDFMValues;
  xdsEinzelkontaktRabattsatz.BeforeLoadDFMValues;
  xdsEinzelkontaktStundensatz.BeforeLoadDFMValues;
  xdsEinzelkontaktKontonummer.BeforeLoadDFMValues;
  xdsEinzelkontaktBank.BeforeLoadDFMValues;
  xdsEinzelkontaktBankleitzahl.BeforeLoadDFMValues;
  xdsEinzelkontaktKontoinhaber.BeforeLoadDFMValues;
  xdsEinzelkontaktBetreuer.BeforeLoadDFMValues;
  xdsEinzelkontaktQuelle.BeforeLoadDFMValues;
  xdsEinzelkontaktSuchmerkmal.BeforeLoadDFMValues;
  xdsEinzelkontaktWarenkreditlimit.BeforeLoadDFMValues;
  xdsEinzelkontaktWarenkreditgesperrt.BeforeLoadDFMValues;
  xdsEinzelkontaktKundennummerFremd.BeforeLoadDFMValues;
  xdsEinzelkontaktKeinNewsletter.BeforeLoadDFMValues;
  xdsEinzelkontaktDebitorennummer.BeforeLoadDFMValues;
  xdsEinzelkontaktKreditorennummer.BeforeLoadDFMValues;
  xdsEinzelkontaktTelefonAlternativ.BeforeLoadDFMValues;
  xdsEinzelkontaktKostentraeger.BeforeLoadDFMValues;
  xdsEinzelkontaktIBAN.BeforeLoadDFMValues;
  xdsEinzelkontaktBIC.BeforeLoadDFMValues;
  xdsEinzelkontaktEmailkonto.BeforeLoadDFMValues;
  xdsEinzelkontaktBenutzername.BeforeLoadDFMValues;
  xdsEinzelkontaktPasswort.BeforeLoadDFMValues;
  xdsEinzelkontaktExportOutlook.BeforeLoadDFMValues;
  xdsEinzelkontaktNichtInListeAnzeigen.BeforeLoadDFMValues;
  xdsEinzelkontaktKreditkarteArt.BeforeLoadDFMValues;
  xdsEinzelkontaktKreditkarteInhaber.BeforeLoadDFMValues;
  xdsEinzelkontaktKreditkarteNummer.BeforeLoadDFMValues;
  xdsEinzelkontaktKreditkarteGueltigMonat.BeforeLoadDFMValues;
  xdsEinzelkontaktKreditkarteGueltigJahr.BeforeLoadDFMValues;
  xdsEinzelkontaktKreditkartePruefziffer.BeforeLoadDFMValues;
  xdsEinzelkontaktDatumNeu.BeforeLoadDFMValues;
  xdsEinzelkontaktDatumgeaendert.BeforeLoadDFMValues;
  xdsEinzelkontaktTitel.BeforeLoadDFMValues;
  xdsEinzelkontaktStundensatzMontage.BeforeLoadDFMValues;
  xdsEinzelkontaktStdMontageU25.BeforeLoadDFMValues;
  xdsEinzelkontaktStdMontageU50.BeforeLoadDFMValues;
  xdsEinzelkontaktStdMontageU70.BeforeLoadDFMValues;
  xdsEinzelkontaktStdMontageU100.BeforeLoadDFMValues;
  xdsEinzelkontaktStdMontageU150.BeforeLoadDFMValues;
  xdsEinzelkontaktStundensatzWerkstatt.BeforeLoadDFMValues;
  xdsEinzelkontaktStdWerkstattU25.BeforeLoadDFMValues;
  xdsEinzelkontaktStdWerkstattU50.BeforeLoadDFMValues;
  xdsEinzelkontaktStdWerkstattU70.BeforeLoadDFMValues;
  xdsEinzelkontaktStdWerkstattU100.BeforeLoadDFMValues;
  xdsEinzelkontaktStdWerkstattU150.BeforeLoadDFMValues;
  xdsEinzelkontaktArchivReferenz.BeforeLoadDFMValues;
  xdsEinzelkontaktErloesKontoUST1.BeforeLoadDFMValues;
  xdsEinzelkontaktErloesKontoUST2.BeforeLoadDFMValues;
  xdsEinzelkontaktErloesKontoUST3.BeforeLoadDFMValues;
  xdsEinzelkontaktGebKal.BeforeLoadDFMValues;
  xdsEinzelkontaktEmailversand.BeforeLoadDFMValues;
  xdsEinzelkontaktMahnspesen.BeforeLoadDFMValues;
  xdsEinzelkontaktRechnungSchluss.BeforeLoadDFMValues;
  xdsEinzelkontaktBenutzerNeu.BeforeLoadDFMValues;
  xdsEinzelkontaktBenutzerGeaendert.BeforeLoadDFMValues;
  xdsEinzelkontaktBelegsprache.BeforeLoadDFMValues;
  xdsEinzelkontaktkmSatz.BeforeLoadDFMValues;
  xdsEinzelkontaktKundenklassetext.BeforeLoadDFMValues;
  xdsEinzelkontaktKundenklasseFarbe.BeforeLoadDFMValues;
  xdsEinzelkontaktAbweichenderRechnungsEmpfaenger.BeforeLoadDFMValues;
  xdsEinzelkontaktProtokoll.BeforeLoadDFMValues;
  xdsEinzelkontaktILNTyp1.BeforeLoadDFMValues;
  xdsEinzelkontaktILNTyp2.BeforeLoadDFMValues;
  xdsEinzelkontaktKontaktGUID.BeforeLoadDFMValues;
  xdsEinzelkontaktPLZGUID.BeforeLoadDFMValues;
  xdsEinzelkontaktPreislistenVariantePakete.BeforeLoadDFMValues;
  xdsEinzelkontaktSchluesselRechnungslauf.BeforeLoadDFMValues;
  xdsEinzelkontaktRechnungEmail.BeforeLoadDFMValues;
  xdsEinzelkontaktZahlungsbedingungEK.BeforeLoadDFMValues;
  xdsEinzelkontaktTransportbedingungEK.BeforeLoadDFMValues;
  xdsEinzelkontaktRabattsatzEK.BeforeLoadDFMValues;
  xdsEinzelkontaktVertreterMatchcode.BeforeLoadDFMValues;
  xdsEinzelkontaktVertreterProvisionssatz.BeforeLoadDFMValues;
  xdsEinzelkontaktUmsatzVKJahr.BeforeLoadDFMValues;
  xdsEinzelkontaktUmsatzVKVorjahr.BeforeLoadDFMValues;
  xdsEinzelkontaktUmsatzEKJahr.BeforeLoadDFMValues;
  xdsEinzelkontaktUmsatzEKVorjahr.BeforeLoadDFMValues;
  xdsEinzelkontaktSteuernummer.BeforeLoadDFMValues;
  xdsEinzelkontaktLoginPW.BeforeLoadDFMValues;
  xdsEinzelkontaktREperFax.BeforeLoadDFMValues;
  xdsEinzelkontaktErreichbarkeit.BeforeLoadDFMValues;
  xdsEinzelkontaktErloesKontoUST4.BeforeLoadDFMValues;
  xdsEinzelkontaktErloesKontoUST5.BeforeLoadDFMValues;
  xdsEinzelkontaktErloesKontoUST6.BeforeLoadDFMValues;
  xdsEinzelkontaktBesteuerungKey.BeforeLoadDFMValues;
  xdsEinzelkontaktAuftraegeJahr.BeforeLoadDFMValues;
  xdsEinzelkontaktAuftraegeVorjahr.BeforeLoadDFMValues;
  xdsEinzelkontaktLieferadresseID.BeforeLoadDFMValues;
  xdsEinzelkontaktUSTIDgeprueft.BeforeLoadDFMValues;
  xdsEinzelkontaktKontaktverbund.BeforeLoadDFMValues;
  xdsEinzelkontaktHinweis.BeforeLoadDFMValues;
  xdsEinzelkontaktLatitude.BeforeLoadDFMValues;
  xdsEinzelkontaktLongitude.BeforeLoadDFMValues;
  xdsEinzelkontaktkmLuftlinie.BeforeLoadDFMValues;
  xdsEinzelkontaktGoogleID.BeforeLoadDFMValues;
  xdsEinzelkontaktGoogleUpdatedUTC.BeforeLoadDFMValues;
  xdsEinzelkontaktBundesland.BeforeLoadDFMValues;
  xdsEinzelkontaktRegion.BeforeLoadDFMValues;
  xdsEinzelkontaktMandatsreferenz.BeforeLoadDFMValues;
  xdsEinzelkontaktMandatsreferenzVom.BeforeLoadDFMValues;
  xdsEinzelkontaktLastschriftArt.BeforeLoadDFMValues;
  xdsEinzelkontaktMahnsperre.BeforeLoadDFMValues;
  xdsEinzelkontaktSuchbegriff.BeforeLoadDFMValues;
  xdsEinzelkontaktLieferanschriftDaten.BeforeLoadDFMValues;
  xdsEinzelkontaktExportKasse.BeforeLoadDFMValues;
  xdsEinzelkontaktLoeschvormerkungDatum.BeforeLoadDFMValues;
  xdsEinzelkontaktLoeschvormerkungGrund.BeforeLoadDFMValues;
  xdsEinzelkontaktPseudonymisiert.BeforeLoadDFMValues;
  xdsEinzelkontaktLoginAktiv.BeforeLoadDFMValues;
  xdsEinzelkontaktSonstigeDaten.BeforeLoadDFMValues;
  xdsEinzelkontaktB2C.BeforeLoadDFMValues;
  xdsEinzelkontaktTIN.BeforeLoadDFMValues;
  xdsEinzelkontaktMindestbestellwert.BeforeLoadDFMValues;
  xdsLaender.BeforeLoadDFMValues;
  xdsLaenderLaenderkuerzel.BeforeLoadDFMValues;
  xdsLaenderLand.BeforeLoadDFMValues;
  sourceLaender.BeforeLoadDFMValues;
  xdsBestKey.BeforeLoadDFMValues;
  xdsBestKeyBesteuerungKey.BeforeLoadDFMValues;
  xdsBestKeyBesteuerungKurzText.BeforeLoadDFMValues;
  xdsBestKeyBesteuerungLangText.BeforeLoadDFMValues;
  xdsBestKeyUmsatzsteuerausweis.BeforeLoadDFMValues;
  xdsBestKeyKtoVorsteuerSatz1.BeforeLoadDFMValues;
  xdsBestKeyKtoVorsteuerSatz2.BeforeLoadDFMValues;
  xdsBestKeyKtoVorsteuerSatz3.BeforeLoadDFMValues;
  xdsBestKeyKtoVorsteuerSatz4.BeforeLoadDFMValues;
  xdsBestKeyKtoVorsteuerSatz5.BeforeLoadDFMValues;
  xdsBestKeyKtoVorsteuerSatz6.BeforeLoadDFMValues;
  xdsBestKeyKtoErloeseSatz1.BeforeLoadDFMValues;
  xdsBestKeyKtoErloeseSatz2.BeforeLoadDFMValues;
  xdsBestKeyKtoErloeseSatz3.BeforeLoadDFMValues;
  xdsBestKeyKtoErloeseSatz4.BeforeLoadDFMValues;
  xdsBestKeyKtoErloeseSatz5.BeforeLoadDFMValues;
  xdsBestKeyKtoErloeseSatz6.BeforeLoadDFMValues;
  xdsBestKeyKtoSkontoaufwandSatz1.BeforeLoadDFMValues;
  xdsBestKeyKtoSkontoaufwandSatz2.BeforeLoadDFMValues;
  xdsBestKeyKtoSkontoaufwandSatz3.BeforeLoadDFMValues;
  xdsBestKeyKtoSkontoaufwandSatz4.BeforeLoadDFMValues;
  xdsBestKeyKtoSkontoaufwandSatz5.BeforeLoadDFMValues;
  xdsBestKeyKtoSkontoaufwandSatz6.BeforeLoadDFMValues;
  xdsBestKeyKtoSkontoertragSatz1.BeforeLoadDFMValues;
  xdsBestKeyKtoSkontoertragSatz2.BeforeLoadDFMValues;
  xdsBestKeyKtoSkontoertragSatz3.BeforeLoadDFMValues;
  xdsBestKeyKtoSkontoertragSatz4.BeforeLoadDFMValues;
  xdsBestKeyKtoSkontoertragSatz5.BeforeLoadDFMValues;
  xdsBestKeyKtoSkontoertragSatz6.BeforeLoadDFMValues;
  xdsBestKeyKtoErloesschmaelerungenSatz1.BeforeLoadDFMValues;
  xdsBestKeyKtoErloesschmaelerungenSatz2.BeforeLoadDFMValues;
  xdsBestKeyKtoErloesschmaelerungenSatz3.BeforeLoadDFMValues;
  xdsBestKeyKtoErloesschmaelerungenSatz4.BeforeLoadDFMValues;
  xdsBestKeyKtoErloesschmaelerungenSatz5.BeforeLoadDFMValues;
  xdsBestKeyKtoErloesschmaelerungenSatz6.BeforeLoadDFMValues;
  xdsBestKeyNatura.BeforeLoadDFMValues;
  xdsBestKeyBSchl_UST_Satz1.BeforeLoadDFMValues;
  xdsBestKeyBSchl_UST_Satz2.BeforeLoadDFMValues;
  xdsBestKeyBSchl_UST_Satz3.BeforeLoadDFMValues;
  xdsBestKeyBSchl_UST_Satz4.BeforeLoadDFMValues;
  xdsBestKeyBSchl_UST_Satz5.BeforeLoadDFMValues;
  xdsBestKeyBSchl_UST_Satz6.BeforeLoadDFMValues;
  xdsBestKeyBSchl_Vorsteuer_Satz1.BeforeLoadDFMValues;
  xdsBestKeyBSchl_Vorsteuer_Satz2.BeforeLoadDFMValues;
  xdsBestKeyBSchl_Vorsteuer_Satz3.BeforeLoadDFMValues;
  xdsBestKeyBSchl_Vorsteuer_Satz4.BeforeLoadDFMValues;
  xdsBestKeyBSchl_Vorsteuer_Satz5.BeforeLoadDFMValues;
  xdsBestKeyBSchl_Vorsteuer_Satz6.BeforeLoadDFMValues;
  xdsBestKeyDokTyp.BeforeLoadDFMValues;
  sourceBestKey.BeforeLoadDFMValues;
  try
    Name := 'KontaktAenderung';
    Width := 640;
    Height := 480;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1 border border-info';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 2;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 32;
    TC.Top := 251;
    TC.Width := 152;
    TC.Height := 110;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 3;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    TC.Footer.ButtonElementClassName := 'btn btn-light';
    TC.Footer.DropDownElementClassName := 'form-control';
    TC.Footer.InputElementClassName := 'form-control';
    TC.Footer.LinkActiveElementClassName := 'link-primary';
    TC.Footer.LinkElementClassName := 'link-secondary';
    TC.Footer.ListElementClassName := 'pagination';
    TC.Footer.ListItemElementClassName := 'page-item';
    TC.Footer.ListLinkElementClassName := 'page-link';
    TC.Header.ButtonActiveElementClassName := 'btn btn-primary';
    TC.Header.ButtonElementClassName := 'btn btn-light';
    TC.Header.DropDownElementClassName := 'form-control';
    TC.Header.InputElementClassName := 'form-control';
    TC.Header.LinkActiveElementClassName := 'link-primary';
    TC.Header.LinkElementClassName := 'link-secondary';
    TC.Header.ListElementClassName := 'pagination';
    TC.Header.ListItemElementClassName := 'page-item';
    TC.Header.ListLinkElementClassName := 'page-link';
    TC.WordWrap := True;
    TC.ColCount := 2;
    edtStrasse.SetParentComponent(Self);
    edtStrasse.Name := 'edtStrasse';
    edtStrasse.Left := 352;
    edtStrasse.Top := 200;
    edtStrasse.Width := 220;
    edtStrasse.Height := 22;
    edtStrasse.ChildOrder := 4;
    edtStrasse.ElementClassName := 'form-control';
    edtStrasse.ElementFont := efCSS;
    edtStrasse.HeightStyle := ssAuto;
    edtStrasse.HeightPercent := 100.000000000000000000;
    edtStrasse.Text := 'edtStrasse';
    edtStrasse.WidthPercent := 100.000000000000000000;
    edtStrasse.DataField := 'Strasse';
    edtStrasse.DataSource := sourceEinzelkontakt;
    edtPostleitzahl.SetParentComponent(Self);
    edtPostleitzahl.Name := 'edtPostleitzahl';
    edtPostleitzahl.Left := 352;
    edtPostleitzahl.Top := 228;
    edtPostleitzahl.Width := 220;
    edtPostleitzahl.Height := 22;
    edtPostleitzahl.ChildOrder := 4;
    edtPostleitzahl.ElementClassName := 'form-control';
    edtPostleitzahl.ElementFont := efCSS;
    edtPostleitzahl.HeightStyle := ssAuto;
    edtPostleitzahl.HeightPercent := 100.000000000000000000;
    edtPostleitzahl.Text := 'WebDBEdit1';
    edtPostleitzahl.WidthPercent := 100.000000000000000000;
    edtPostleitzahl.DataField := 'Postleitzahl';
    edtPostleitzahl.DataSource := sourceEinzelkontakt;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 158;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    btnSpeichern.SetParentComponent(Self);
    btnSpeichern.Name := 'btnSpeichern';
    btnSpeichern.Left := 102;
    btnSpeichern.Top := 158;
    btnSpeichern.Width := 96;
    btnSpeichern.Height := 25;
    btnSpeichern.Caption := 'speichern';
    btnSpeichern.ChildOrder := 4;
    btnSpeichern.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnSpeichern.ElementFont := efCSS;
    btnSpeichern.ElementPosition := epIgnore;
    btnSpeichern.HeightStyle := ssAuto;
    btnSpeichern.HeightPercent := 100.000000000000000000;
    btnSpeichern.WidthStyle := ssAuto;
    btnSpeichern.WidthPercent := 100.000000000000000000;
    SetEvent(btnSpeichern, Self, 'OnClick', 'btnSpeichernClick');
    edtVorname.SetParentComponent(Self);
    edtVorname.Name := 'edtVorname';
    edtVorname.Left := 352;
    edtVorname.Top := 80;
    edtVorname.Width := 220;
    edtVorname.Height := 22;
    edtVorname.ChildOrder := 4;
    edtVorname.ElementClassName := 'form-control';
    edtVorname.ElementFont := efCSS;
    edtVorname.HeightStyle := ssAuto;
    edtVorname.HeightPercent := 100.000000000000000000;
    edtVorname.Text := 'edtStrasse';
    edtVorname.WidthPercent := 100.000000000000000000;
    edtVorname.DataField := 'Vorname';
    edtVorname.DataSource := sourceEinzelkontakt;
    edtAdresszeile2.SetParentComponent(Self);
    edtAdresszeile2.Name := 'edtAdresszeile2';
    edtAdresszeile2.Left := 352;
    edtAdresszeile2.Top := 108;
    edtAdresszeile2.Width := 220;
    edtAdresszeile2.Height := 22;
    edtAdresszeile2.ChildOrder := 4;
    edtAdresszeile2.ElementClassName := 'form-control';
    edtAdresszeile2.ElementFont := efCSS;
    edtAdresszeile2.HeightStyle := ssAuto;
    edtAdresszeile2.HeightPercent := 100.000000000000000000;
    edtAdresszeile2.Text := 'edtStrasse';
    edtAdresszeile2.WidthPercent := 100.000000000000000000;
    edtAdresszeile2.DataField := 'Adresszeile2';
    edtAdresszeile2.DataSource := sourceEinzelkontakt;
    edtAdresszeile3.SetParentComponent(Self);
    edtAdresszeile3.Name := 'edtAdresszeile3';
    edtAdresszeile3.Left := 352;
    edtAdresszeile3.Top := 136;
    edtAdresszeile3.Width := 220;
    edtAdresszeile3.Height := 22;
    edtAdresszeile3.ChildOrder := 4;
    edtAdresszeile3.ElementClassName := 'form-control';
    edtAdresszeile3.ElementFont := efCSS;
    edtAdresszeile3.HeightStyle := ssAuto;
    edtAdresszeile3.HeightPercent := 100.000000000000000000;
    edtAdresszeile3.Text := 'edtStrasse';
    edtAdresszeile3.WidthPercent := 100.000000000000000000;
    edtAdresszeile3.DataField := 'Adresszeile3';
    edtAdresszeile3.DataSource := sourceEinzelkontakt;
    edtOrt.SetParentComponent(Self);
    edtOrt.Name := 'edtOrt';
    edtOrt.Left := 352;
    edtOrt.Top := 256;
    edtOrt.Width := 220;
    edtOrt.Height := 22;
    edtOrt.ChildOrder := 4;
    edtOrt.ElementClassName := 'form-control';
    edtOrt.ElementFont := efCSS;
    edtOrt.HeightStyle := ssAuto;
    edtOrt.HeightPercent := 100.000000000000000000;
    edtOrt.Text := 'edtOrt';
    edtOrt.WidthPercent := 100.000000000000000000;
    edtOrt.DataField := 'Ort';
    edtOrt.DataSource := sourceEinzelkontakt;
    edtLand.SetParentComponent(Self);
    edtLand.Name := 'edtLand';
    edtLand.Left := 352;
    edtLand.Top := 296;
    edtLand.Width := 220;
    edtLand.Height := 22;
    edtLand.ElementClassName := 'form-control';
    edtLand.ElementFont := efCSS;
    edtLand.HeightStyle := ssAuto;
    edtLand.HeightPercent := 100.000000000000000000;
    edtLand.WidthPercent := 100.000000000000000000;
    edtLand.DataField := 'Land';
    edtLand.DataSource := sourceEinzelkontakt;
    edtLand.KeyField := 'Land';
    edtLand.ListField := 'Land';
    edtLand.ListSource := sourceLaender;
    edtTelefon.SetParentComponent(Self);
    edtTelefon.Name := 'edtTelefon';
    edtTelefon.Left := 352;
    edtTelefon.Top := 324;
    edtTelefon.Width := 220;
    edtTelefon.Height := 22;
    edtTelefon.ChildOrder := 4;
    edtTelefon.ElementClassName := 'form-control';
    edtTelefon.ElementFont := efCSS;
    edtTelefon.HeightStyle := ssAuto;
    edtTelefon.HeightPercent := 100.000000000000000000;
    edtTelefon.Text := 'edtTelefon';
    edtTelefon.WidthPercent := 100.000000000000000000;
    edtTelefon.DataField := 'TelefonNummer';
    edtTelefon.DataSource := sourceEinzelkontakt;
    edtTelefonAlternativ.SetParentComponent(Self);
    edtTelefonAlternativ.Name := 'edtTelefonAlternativ';
    edtTelefonAlternativ.Left := 352;
    edtTelefonAlternativ.Top := 352;
    edtTelefonAlternativ.Width := 220;
    edtTelefonAlternativ.Height := 22;
    edtTelefonAlternativ.ChildOrder := 4;
    edtTelefonAlternativ.ElementClassName := 'form-control';
    edtTelefonAlternativ.ElementFont := efCSS;
    edtTelefonAlternativ.HeightStyle := ssAuto;
    edtTelefonAlternativ.HeightPercent := 100.000000000000000000;
    edtTelefonAlternativ.Text := 'edtTelefon';
    edtTelefonAlternativ.WidthPercent := 100.000000000000000000;
    edtTelefonAlternativ.DataField := 'TelefonAlternativ';
    edtTelefonAlternativ.DataSource := sourceEinzelkontakt;
    edtTelefonMobil.SetParentComponent(Self);
    edtTelefonMobil.Name := 'edtTelefonMobil';
    edtTelefonMobil.Left := 352;
    edtTelefonMobil.Top := 380;
    edtTelefonMobil.Width := 220;
    edtTelefonMobil.Height := 22;
    edtTelefonMobil.ChildOrder := 4;
    edtTelefonMobil.ElementClassName := 'form-control';
    edtTelefonMobil.ElementFont := efCSS;
    edtTelefonMobil.HeightStyle := ssAuto;
    edtTelefonMobil.HeightPercent := 100.000000000000000000;
    edtTelefonMobil.Text := 'edtTelefon';
    edtTelefonMobil.WidthPercent := 100.000000000000000000;
    edtTelefonMobil.DataField := 'MobilTelefon';
    edtTelefonMobil.DataSource := sourceEinzelkontakt;
    edtInternet.SetParentComponent(Self);
    edtInternet.Name := 'edtInternet';
    edtInternet.Left := 352;
    edtInternet.Top := 408;
    edtInternet.Width := 220;
    edtInternet.Height := 22;
    edtInternet.ChildOrder := 4;
    edtInternet.ElementClassName := 'form-control';
    edtInternet.ElementFont := efCSS;
    edtInternet.HeightStyle := ssAuto;
    edtInternet.HeightPercent := 100.000000000000000000;
    edtInternet.Text := 'edtTelefon';
    edtInternet.WidthPercent := 100.000000000000000000;
    edtInternet.DataField := 'Internet';
    edtInternet.DataSource := sourceEinzelkontakt;
    edtEmail.SetParentComponent(Self);
    edtEmail.Name := 'edtEmail';
    edtEmail.Left := 352;
    edtEmail.Top := 436;
    edtEmail.Width := 220;
    edtEmail.Height := 22;
    edtEmail.ChildOrder := 4;
    edtEmail.ElementClassName := 'form-control';
    edtEmail.ElementFont := efCSS;
    edtEmail.HeightStyle := ssAuto;
    edtEmail.HeightPercent := 100.000000000000000000;
    edtEmail.Text := 'edtTelefon';
    edtEmail.WidthPercent := 100.000000000000000000;
    edtEmail.DataField := 'EMail';
    edtEmail.DataSource := sourceEinzelkontakt;
    edtAdressanrede.SetParentComponent(Self);
    edtAdressanrede.Name := 'edtAdressanrede';
    edtAdressanrede.Left := 352;
    edtAdressanrede.Top := 52;
    edtAdressanrede.Width := 220;
    edtAdressanrede.Height := 22;
    edtAdressanrede.ChildOrder := 4;
    edtAdressanrede.ElementClassName := 'form-control';
    edtAdressanrede.ElementFont := efCSS;
    edtAdressanrede.HeightStyle := ssAuto;
    edtAdressanrede.HeightPercent := 100.000000000000000000;
    edtAdressanrede.Text := 'edtStrasse';
    edtAdressanrede.WidthPercent := 100.000000000000000000;
    edtAdressanrede.DataField := 'Adressanrede';
    edtAdressanrede.DataSource := sourceEinzelkontakt;
    edtTitel.SetParentComponent(Self);
    edtTitel.Name := 'edtTitel';
    edtTitel.Left := 352;
    edtTitel.Top := 24;
    edtTitel.Width := 220;
    edtTitel.Height := 22;
    edtTitel.ChildOrder := 4;
    edtTitel.ElementClassName := 'form-control';
    edtTitel.ElementFont := efCSS;
    edtTitel.HeightStyle := ssAuto;
    edtTitel.HeightPercent := 100.000000000000000000;
    edtTitel.Text := 'edtStrasse';
    edtTitel.WidthPercent := 100.000000000000000000;
    edtTitel.DataField := 'Titel';
    edtTitel.DataSource := sourceEinzelkontakt;
    edtNachname.SetParentComponent(Self);
    edtNachname.Name := 'edtNachname';
    edtNachname.Left := 352;
    edtNachname.Top := -4;
    edtNachname.Width := 220;
    edtNachname.Height := 22;
    edtNachname.ChildOrder := 4;
    edtNachname.ElementClassName := 'form-control';
    edtNachname.ElementFont := efCSS;
    edtNachname.HeightStyle := ssAuto;
    edtNachname.HeightPercent := 100.000000000000000000;
    edtNachname.ReadOnly := True;
    edtNachname.Text := 'edtStrasse';
    edtNachname.WidthPercent := 100.000000000000000000;
    edtNachname.DataField := 'Nachname';
    edtNachname.DataSource := sourceEinzelkontakt;
    sourceEinzelkontakt.SetParentComponent(Self);
    sourceEinzelkontakt.Name := 'sourceEinzelkontakt';
    sourceEinzelkontakt.DataSet := xdsEinzelkontakt;
    SetEvent(sourceEinzelkontakt, Self, 'OnStateChange', 'sourceEinzelkontaktStateChange');
    sourceEinzelkontakt.Left := 52;
    sourceEinzelkontakt.Top := 165;
    xdsEinzelkontakt.SetParentComponent(Self);
    xdsEinzelkontakt.Name := 'xdsEinzelkontakt';
    xdsEinzelkontakt.AfterApplyUpdates := xdsEinzelkontaktAfterApplyUpdates;
    xdsEinzelkontakt.AfterOpen := xdsEinzelkontaktAfterOpen;
    xdsEinzelkontakt.BeforePost := xdsEinzelkontaktBeforePost;
    xdsEinzelkontakt.AfterPost := xdsEinzelkontaktAfterPost;
    xdsEinzelkontakt.EntitySetName := 'Adressen';
    xdsEinzelkontakt.Connection := DM2.XDataWebConnection1;
    xdsEinzelkontakt.QueryTop := 1;
    xdsEinzelkontakt.Left := 52;
    xdsEinzelkontakt.Top := 221;
    xdsEinzelkontaktKundennummer.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKundennummer.Name := 'xdsEinzelkontaktKundennummer';
    xdsEinzelkontaktKundennummer.FieldName := 'Kundennummer';
    xdsEinzelkontaktKundennummer.Required := True;
    xdsEinzelkontaktKundennummer.Size := 13;
    xdsEinzelkontaktGruppeKunden.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktGruppeKunden.Name := 'xdsEinzelkontaktGruppeKunden';
    xdsEinzelkontaktGruppeKunden.FieldName := 'GruppeKunden';
    xdsEinzelkontaktGruppeLieferanten.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktGruppeLieferanten.Name := 'xdsEinzelkontaktGruppeLieferanten';
    xdsEinzelkontaktGruppeLieferanten.FieldName := 'GruppeLieferanten';
    xdsEinzelkontaktGruppeSonstige.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktGruppeSonstige.Name := 'xdsEinzelkontaktGruppeSonstige';
    xdsEinzelkontaktGruppeSonstige.FieldName := 'GruppeSonstige';
    xdsEinzelkontaktGruppeNichtkunden.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktGruppeNichtkunden.Name := 'xdsEinzelkontaktGruppeNichtkunden';
    xdsEinzelkontaktGruppeNichtkunden.FieldName := 'GruppeNichtkunden';
    xdsEinzelkontaktKontaktgruppe.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKontaktgruppe.Name := 'xdsEinzelkontaktKontaktgruppe';
    xdsEinzelkontaktKontaktgruppe.FieldName := 'Kontaktgruppe';
    xdsEinzelkontaktKontaktgruppe.Size := 50;
    xdsEinzelkontaktNachname.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktNachname.Name := 'xdsEinzelkontaktNachname';
    xdsEinzelkontaktNachname.FieldName := 'Nachname';
    xdsEinzelkontaktNachname.Size := 40;
    xdsEinzelkontaktVorname.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktVorname.Name := 'xdsEinzelkontaktVorname';
    xdsEinzelkontaktVorname.FieldName := 'Vorname';
    xdsEinzelkontaktVorname.Size := 40;
    xdsEinzelkontaktAdresszeile2.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktAdresszeile2.Name := 'xdsEinzelkontaktAdresszeile2';
    xdsEinzelkontaktAdresszeile2.FieldName := 'Adresszeile2';
    xdsEinzelkontaktAdresszeile2.Size := 40;
    xdsEinzelkontaktAdresszeile3.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktAdresszeile3.Name := 'xdsEinzelkontaktAdresszeile3';
    xdsEinzelkontaktAdresszeile3.FieldName := 'Adresszeile3';
    xdsEinzelkontaktAdresszeile3.Size := 40;
    xdsEinzelkontaktStrasse.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStrasse.Name := 'xdsEinzelkontaktStrasse';
    xdsEinzelkontaktStrasse.FieldName := 'Strasse';
    xdsEinzelkontaktStrasse.Size := 40;
    xdsEinzelkontaktPostleitzahl.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktPostleitzahl.Name := 'xdsEinzelkontaktPostleitzahl';
    xdsEinzelkontaktPostleitzahl.FieldName := 'Postleitzahl';
    xdsEinzelkontaktPostleitzahl.Size := 6;
    xdsEinzelkontaktOrt.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktOrt.Name := 'xdsEinzelkontaktOrt';
    xdsEinzelkontaktOrt.FieldName := 'Ort';
    xdsEinzelkontaktOrt.Size := 40;
    xdsEinzelkontaktLaenderkuerzel.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktLaenderkuerzel.Name := 'xdsEinzelkontaktLaenderkuerzel';
    xdsEinzelkontaktLaenderkuerzel.FieldName := 'Laenderkuerzel';
    xdsEinzelkontaktLaenderkuerzel.Size := 5;
    xdsEinzelkontaktLand.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktLand.Name := 'xdsEinzelkontaktLand';
    xdsEinzelkontaktLand.FieldName := 'Land';
    xdsEinzelkontaktLand.Size := 40;
    xdsEinzelkontaktLaenderkennzeichen.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktLaenderkennzeichen.Name := 'xdsEinzelkontaktLaenderkennzeichen';
    xdsEinzelkontaktLaenderkennzeichen.FieldName := 'Laenderkennzeichen';
    xdsEinzelkontaktAdressanrede.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktAdressanrede.Name := 'xdsEinzelkontaktAdressanrede';
    xdsEinzelkontaktAdressanrede.FieldName := 'Adressanrede';
    xdsEinzelkontaktAdressanrede.Size := 15;
    xdsEinzelkontaktBriefanrede1.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBriefanrede1.Name := 'xdsEinzelkontaktBriefanrede1';
    xdsEinzelkontaktBriefanrede1.FieldName := 'Briefanrede1';
    xdsEinzelkontaktBriefanrede1.Size := 255;
    xdsEinzelkontaktBriefanrede2.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBriefanrede2.Name := 'xdsEinzelkontaktBriefanrede2';
    xdsEinzelkontaktBriefanrede2.FieldName := 'Briefanrede2';
    xdsEinzelkontaktBriefanrede2.Size := 40;
    xdsEinzelkontaktAdresseBild.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktAdresseBild.Name := 'xdsEinzelkontaktAdresseBild';
    xdsEinzelkontaktAdresseBild.FieldName := 'AdresseBild';
    xdsEinzelkontaktAdresseBild.Size := 255;
    xdsEinzelkontaktLieferanschrift.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktLieferanschrift.Name := 'xdsEinzelkontaktLieferanschrift';
    xdsEinzelkontaktLieferanschrift.FieldName := 'Lieferanschrift';
    xdsEinzelkontaktLieferanschrift.Size := 255;
    xdsEinzelkontaktGeburtsdatum.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktGeburtsdatum.Name := 'xdsEinzelkontaktGeburtsdatum';
    xdsEinzelkontaktGeburtsdatum.FieldName := 'Geburtsdatum';
    xdsEinzelkontaktTelefonNummer.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktTelefonNummer.Name := 'xdsEinzelkontaktTelefonNummer';
    xdsEinzelkontaktTelefonNummer.FieldName := 'TelefonNummer';
    xdsEinzelkontaktTelefonNummer.Size := 25;
    xdsEinzelkontaktTelefaxNummer.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktTelefaxNummer.Name := 'xdsEinzelkontaktTelefaxNummer';
    xdsEinzelkontaktTelefaxNummer.FieldName := 'TelefaxNummer';
    xdsEinzelkontaktTelefaxNummer.Size := 25;
    xdsEinzelkontaktMobilTelefon.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktMobilTelefon.Name := 'xdsEinzelkontaktMobilTelefon';
    xdsEinzelkontaktMobilTelefon.FieldName := 'MobilTelefon';
    xdsEinzelkontaktMobilTelefon.Size := 25;
    xdsEinzelkontaktEMail.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktEMail.Name := 'xdsEinzelkontaktEMail';
    xdsEinzelkontaktEMail.FieldName := 'EMail';
    xdsEinzelkontaktEMail.Size := 50;
    xdsEinzelkontaktInternet.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktInternet.Name := 'xdsEinzelkontaktInternet';
    xdsEinzelkontaktInternet.FieldName := 'Internet';
    xdsEinzelkontaktInternet.Size := 50;
    xdsEinzelkontaktUmsatzsteuerID.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktUmsatzsteuerID.Name := 'xdsEinzelkontaktUmsatzsteuerID';
    xdsEinzelkontaktUmsatzsteuerID.FieldName := 'UmsatzsteuerID';
    xdsEinzelkontaktUmsatzsteuerausweis.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktUmsatzsteuerausweis.Name := 'xdsEinzelkontaktUmsatzsteuerausweis';
    xdsEinzelkontaktUmsatzsteuerausweis.FieldName := 'Umsatzsteuerausweis';
    xdsEinzelkontaktBemerkungen.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBemerkungen.Name := 'xdsEinzelkontaktBemerkungen';
    xdsEinzelkontaktBemerkungen.FieldName := 'Bemerkungen';
    xdsEinzelkontaktBemerkungen.Size := 255;
    xdsEinzelkontaktBranche.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBranche.Name := 'xdsEinzelkontaktBranche';
    xdsEinzelkontaktBranche.FieldName := 'Branche';
    xdsEinzelkontaktBranche.Size := 50;
    xdsEinzelkontaktSelektiert1.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktSelektiert1.Name := 'xdsEinzelkontaktSelektiert1';
    xdsEinzelkontaktSelektiert1.FieldName := 'Selektiert1';
    xdsEinzelkontaktSelektiert2.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktSelektiert2.Name := 'xdsEinzelkontaktSelektiert2';
    xdsEinzelkontaktSelektiert2.FieldName := 'Selektiert2';
    xdsEinzelkontaktSelektiert3.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktSelektiert3.Name := 'xdsEinzelkontaktSelektiert3';
    xdsEinzelkontaktSelektiert3.FieldName := 'Selektiert3';
    xdsEinzelkontaktZahlungsbedingung.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktZahlungsbedingung.Name := 'xdsEinzelkontaktZahlungsbedingung';
    xdsEinzelkontaktZahlungsbedingung.FieldName := 'Zahlungsbedingung';
    xdsEinzelkontaktTransportbedingung.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktTransportbedingung.Name := 'xdsEinzelkontaktTransportbedingung';
    xdsEinzelkontaktTransportbedingung.FieldName := 'Transportbedingung';
    xdsEinzelkontaktTransportbedingung.Size := 100;
    xdsEinzelkontaktKilometer.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKilometer.Name := 'xdsEinzelkontaktKilometer';
    xdsEinzelkontaktKilometer.FieldName := 'Kilometer';
    xdsEinzelkontaktRabattsatz.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktRabattsatz.Name := 'xdsEinzelkontaktRabattsatz';
    xdsEinzelkontaktRabattsatz.FieldName := 'Rabattsatz';
    xdsEinzelkontaktStundensatz.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStundensatz.Name := 'xdsEinzelkontaktStundensatz';
    xdsEinzelkontaktStundensatz.FieldName := 'Stundensatz';
    xdsEinzelkontaktKontonummer.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKontonummer.Name := 'xdsEinzelkontaktKontonummer';
    xdsEinzelkontaktKontonummer.FieldName := 'Kontonummer';
    xdsEinzelkontaktKontonummer.Size := 50;
    xdsEinzelkontaktBank.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBank.Name := 'xdsEinzelkontaktBank';
    xdsEinzelkontaktBank.FieldName := 'Bank';
    xdsEinzelkontaktBank.Size := 50;
    xdsEinzelkontaktBankleitzahl.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBankleitzahl.Name := 'xdsEinzelkontaktBankleitzahl';
    xdsEinzelkontaktBankleitzahl.FieldName := 'Bankleitzahl';
    xdsEinzelkontaktKontoinhaber.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKontoinhaber.Name := 'xdsEinzelkontaktKontoinhaber';
    xdsEinzelkontaktKontoinhaber.FieldName := 'Kontoinhaber';
    xdsEinzelkontaktKontoinhaber.Size := 50;
    xdsEinzelkontaktBetreuer.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBetreuer.Name := 'xdsEinzelkontaktBetreuer';
    xdsEinzelkontaktBetreuer.FieldName := 'Betreuer';
    xdsEinzelkontaktBetreuer.Size := 50;
    xdsEinzelkontaktQuelle.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktQuelle.Name := 'xdsEinzelkontaktQuelle';
    xdsEinzelkontaktQuelle.FieldName := 'Quelle';
    xdsEinzelkontaktQuelle.Size := 100;
    xdsEinzelkontaktSuchmerkmal.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktSuchmerkmal.Name := 'xdsEinzelkontaktSuchmerkmal';
    xdsEinzelkontaktSuchmerkmal.FieldName := 'Suchmerkmal';
    xdsEinzelkontaktSuchmerkmal.Size := 250;
    xdsEinzelkontaktWarenkreditlimit.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktWarenkreditlimit.Name := 'xdsEinzelkontaktWarenkreditlimit';
    xdsEinzelkontaktWarenkreditlimit.FieldName := 'Warenkreditlimit';
    xdsEinzelkontaktWarenkreditgesperrt.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktWarenkreditgesperrt.Name := 'xdsEinzelkontaktWarenkreditgesperrt';
    xdsEinzelkontaktWarenkreditgesperrt.FieldName := 'Warenkreditgesperrt';
    xdsEinzelkontaktKundennummerFremd.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKundennummerFremd.Name := 'xdsEinzelkontaktKundennummerFremd';
    xdsEinzelkontaktKundennummerFremd.FieldName := 'KundennummerFremd';
    xdsEinzelkontaktKeinNewsletter.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKeinNewsletter.Name := 'xdsEinzelkontaktKeinNewsletter';
    xdsEinzelkontaktKeinNewsletter.FieldName := 'KeinNewsletter';
    xdsEinzelkontaktDebitorennummer.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktDebitorennummer.Name := 'xdsEinzelkontaktDebitorennummer';
    xdsEinzelkontaktDebitorennummer.FieldName := 'Debitorennummer';
    xdsEinzelkontaktDebitorennummer.Size := 13;
    xdsEinzelkontaktKreditorennummer.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKreditorennummer.Name := 'xdsEinzelkontaktKreditorennummer';
    xdsEinzelkontaktKreditorennummer.FieldName := 'Kreditorennummer';
    xdsEinzelkontaktKreditorennummer.Size := 13;
    xdsEinzelkontaktTelefonAlternativ.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktTelefonAlternativ.Name := 'xdsEinzelkontaktTelefonAlternativ';
    xdsEinzelkontaktTelefonAlternativ.FieldName := 'TelefonAlternativ';
    xdsEinzelkontaktTelefonAlternativ.Size := 50;
    xdsEinzelkontaktKostentraeger.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKostentraeger.Name := 'xdsEinzelkontaktKostentraeger';
    xdsEinzelkontaktKostentraeger.FieldName := 'Kostentraeger';
    xdsEinzelkontaktKostentraeger.Size := 13;
    xdsEinzelkontaktIBAN.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktIBAN.Name := 'xdsEinzelkontaktIBAN';
    xdsEinzelkontaktIBAN.FieldName := 'IBAN';
    xdsEinzelkontaktIBAN.Size := 50;
    xdsEinzelkontaktBIC.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBIC.Name := 'xdsEinzelkontaktBIC';
    xdsEinzelkontaktBIC.FieldName := 'BIC';
    xdsEinzelkontaktEmailkonto.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktEmailkonto.Name := 'xdsEinzelkontaktEmailkonto';
    xdsEinzelkontaktEmailkonto.FieldName := 'Emailkonto';
    xdsEinzelkontaktEmailkonto.Size := 50;
    xdsEinzelkontaktBenutzername.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBenutzername.Name := 'xdsEinzelkontaktBenutzername';
    xdsEinzelkontaktBenutzername.FieldName := 'Benutzername';
    xdsEinzelkontaktBenutzername.Size := 50;
    xdsEinzelkontaktPasswort.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktPasswort.Name := 'xdsEinzelkontaktPasswort';
    xdsEinzelkontaktPasswort.FieldName := 'Passwort';
    xdsEinzelkontaktPasswort.Size := 25;
    xdsEinzelkontaktExportOutlook.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktExportOutlook.Name := 'xdsEinzelkontaktExportOutlook';
    xdsEinzelkontaktExportOutlook.FieldName := 'ExportOutlook';
    xdsEinzelkontaktNichtInListeAnzeigen.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktNichtInListeAnzeigen.Name := 'xdsEinzelkontaktNichtInListeAnzeigen';
    xdsEinzelkontaktNichtInListeAnzeigen.FieldName := 'NichtInListeAnzeigen';
    xdsEinzelkontaktKreditkarteArt.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKreditkarteArt.Name := 'xdsEinzelkontaktKreditkarteArt';
    xdsEinzelkontaktKreditkarteArt.FieldName := 'KreditkarteArt';
    xdsEinzelkontaktKreditkarteArt.Size := 30;
    xdsEinzelkontaktKreditkarteInhaber.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKreditkarteInhaber.Name := 'xdsEinzelkontaktKreditkarteInhaber';
    xdsEinzelkontaktKreditkarteInhaber.FieldName := 'KreditkarteInhaber';
    xdsEinzelkontaktKreditkarteInhaber.Size := 50;
    xdsEinzelkontaktKreditkarteNummer.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKreditkarteNummer.Name := 'xdsEinzelkontaktKreditkarteNummer';
    xdsEinzelkontaktKreditkarteNummer.FieldName := 'KreditkarteNummer';
    xdsEinzelkontaktKreditkarteGueltigMonat.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKreditkarteGueltigMonat.Name := 'xdsEinzelkontaktKreditkarteGueltigMonat';
    xdsEinzelkontaktKreditkarteGueltigMonat.FieldName := 'KreditkarteGueltigMonat';
    xdsEinzelkontaktKreditkarteGueltigMonat.Size := 2;
    xdsEinzelkontaktKreditkarteGueltigJahr.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKreditkarteGueltigJahr.Name := 'xdsEinzelkontaktKreditkarteGueltigJahr';
    xdsEinzelkontaktKreditkarteGueltigJahr.FieldName := 'KreditkarteGueltigJahr';
    xdsEinzelkontaktKreditkartePruefziffer.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKreditkartePruefziffer.Name := 'xdsEinzelkontaktKreditkartePruefziffer';
    xdsEinzelkontaktKreditkartePruefziffer.FieldName := 'KreditkartePruefziffer';
    xdsEinzelkontaktKreditkartePruefziffer.Size := 10;
    xdsEinzelkontaktDatumNeu.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktDatumNeu.Name := 'xdsEinzelkontaktDatumNeu';
    xdsEinzelkontaktDatumNeu.FieldName := 'DatumNeu';
    xdsEinzelkontaktDatumgeaendert.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktDatumgeaendert.Name := 'xdsEinzelkontaktDatumgeaendert';
    xdsEinzelkontaktDatumgeaendert.FieldName := 'Datumgeaendert';
    xdsEinzelkontaktTitel.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktTitel.Name := 'xdsEinzelkontaktTitel';
    xdsEinzelkontaktTitel.FieldName := 'Titel';
    xdsEinzelkontaktStundensatzMontage.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStundensatzMontage.Name := 'xdsEinzelkontaktStundensatzMontage';
    xdsEinzelkontaktStundensatzMontage.FieldName := 'StundensatzMontage';
    xdsEinzelkontaktStdMontageU25.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStdMontageU25.Name := 'xdsEinzelkontaktStdMontageU25';
    xdsEinzelkontaktStdMontageU25.FieldName := 'StdMontageU25';
    xdsEinzelkontaktStdMontageU50.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStdMontageU50.Name := 'xdsEinzelkontaktStdMontageU50';
    xdsEinzelkontaktStdMontageU50.FieldName := 'StdMontageU50';
    xdsEinzelkontaktStdMontageU70.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStdMontageU70.Name := 'xdsEinzelkontaktStdMontageU70';
    xdsEinzelkontaktStdMontageU70.FieldName := 'StdMontageU70';
    xdsEinzelkontaktStdMontageU100.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStdMontageU100.Name := 'xdsEinzelkontaktStdMontageU100';
    xdsEinzelkontaktStdMontageU100.FieldName := 'StdMontageU100';
    xdsEinzelkontaktStdMontageU150.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStdMontageU150.Name := 'xdsEinzelkontaktStdMontageU150';
    xdsEinzelkontaktStdMontageU150.FieldName := 'StdMontageU150';
    xdsEinzelkontaktStundensatzWerkstatt.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStundensatzWerkstatt.Name := 'xdsEinzelkontaktStundensatzWerkstatt';
    xdsEinzelkontaktStundensatzWerkstatt.FieldName := 'StundensatzWerkstatt';
    xdsEinzelkontaktStdWerkstattU25.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStdWerkstattU25.Name := 'xdsEinzelkontaktStdWerkstattU25';
    xdsEinzelkontaktStdWerkstattU25.FieldName := 'StdWerkstattU25';
    xdsEinzelkontaktStdWerkstattU50.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStdWerkstattU50.Name := 'xdsEinzelkontaktStdWerkstattU50';
    xdsEinzelkontaktStdWerkstattU50.FieldName := 'StdWerkstattU50';
    xdsEinzelkontaktStdWerkstattU70.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStdWerkstattU70.Name := 'xdsEinzelkontaktStdWerkstattU70';
    xdsEinzelkontaktStdWerkstattU70.FieldName := 'StdWerkstattU70';
    xdsEinzelkontaktStdWerkstattU100.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStdWerkstattU100.Name := 'xdsEinzelkontaktStdWerkstattU100';
    xdsEinzelkontaktStdWerkstattU100.FieldName := 'StdWerkstattU100';
    xdsEinzelkontaktStdWerkstattU150.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktStdWerkstattU150.Name := 'xdsEinzelkontaktStdWerkstattU150';
    xdsEinzelkontaktStdWerkstattU150.FieldName := 'StdWerkstattU150';
    xdsEinzelkontaktArchivReferenz.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktArchivReferenz.Name := 'xdsEinzelkontaktArchivReferenz';
    xdsEinzelkontaktArchivReferenz.FieldName := 'ArchivReferenz';
    xdsEinzelkontaktArchivReferenz.Size := 55;
    xdsEinzelkontaktErloesKontoUST1.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktErloesKontoUST1.Name := 'xdsEinzelkontaktErloesKontoUST1';
    xdsEinzelkontaktErloesKontoUST1.FieldName := 'ErloesKontoUST1';
    xdsEinzelkontaktErloesKontoUST1.Size := 10;
    xdsEinzelkontaktErloesKontoUST2.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktErloesKontoUST2.Name := 'xdsEinzelkontaktErloesKontoUST2';
    xdsEinzelkontaktErloesKontoUST2.FieldName := 'ErloesKontoUST2';
    xdsEinzelkontaktErloesKontoUST2.Size := 10;
    xdsEinzelkontaktErloesKontoUST3.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktErloesKontoUST3.Name := 'xdsEinzelkontaktErloesKontoUST3';
    xdsEinzelkontaktErloesKontoUST3.FieldName := 'ErloesKontoUST3';
    xdsEinzelkontaktErloesKontoUST3.Size := 10;
    xdsEinzelkontaktGebKal.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktGebKal.Name := 'xdsEinzelkontaktGebKal';
    xdsEinzelkontaktGebKal.FieldName := 'GebKal';
    xdsEinzelkontaktEmailversand.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktEmailversand.Name := 'xdsEinzelkontaktEmailversand';
    xdsEinzelkontaktEmailversand.FieldName := 'Emailversand';
    xdsEinzelkontaktMahnspesen.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktMahnspesen.Name := 'xdsEinzelkontaktMahnspesen';
    xdsEinzelkontaktMahnspesen.FieldName := 'Mahnspesen';
    xdsEinzelkontaktRechnungSchluss.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktRechnungSchluss.Name := 'xdsEinzelkontaktRechnungSchluss';
    xdsEinzelkontaktRechnungSchluss.FieldName := 'RechnungSchluss';
    xdsEinzelkontaktRechnungSchluss.Size := 255;
    xdsEinzelkontaktBenutzerNeu.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBenutzerNeu.Name := 'xdsEinzelkontaktBenutzerNeu';
    xdsEinzelkontaktBenutzerNeu.FieldName := 'BenutzerNeu';
    xdsEinzelkontaktBenutzerNeu.Size := 50;
    xdsEinzelkontaktBenutzerGeaendert.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBenutzerGeaendert.Name := 'xdsEinzelkontaktBenutzerGeaendert';
    xdsEinzelkontaktBenutzerGeaendert.FieldName := 'BenutzerGeaendert';
    xdsEinzelkontaktBenutzerGeaendert.Size := 50;
    xdsEinzelkontaktBelegsprache.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBelegsprache.Name := 'xdsEinzelkontaktBelegsprache';
    xdsEinzelkontaktBelegsprache.FieldName := 'Belegsprache';
    xdsEinzelkontaktBelegsprache.Size := 10;
    xdsEinzelkontaktkmSatz.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktkmSatz.Name := 'xdsEinzelkontaktkmSatz';
    xdsEinzelkontaktkmSatz.FieldName := 'kmSatz';
    xdsEinzelkontaktKundenklassetext.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKundenklassetext.Name := 'xdsEinzelkontaktKundenklassetext';
    xdsEinzelkontaktKundenklassetext.FieldName := 'Kundenklassetext';
    xdsEinzelkontaktKundenklassetext.Size := 50;
    xdsEinzelkontaktKundenklasseFarbe.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKundenklasseFarbe.Name := 'xdsEinzelkontaktKundenklasseFarbe';
    xdsEinzelkontaktKundenklasseFarbe.FieldName := 'KundenklasseFarbe';
    xdsEinzelkontaktAbweichenderRechnungsEmpfaenger.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktAbweichenderRechnungsEmpfaenger.Name := 'xdsEinzelkontaktAbweichenderRechnungsEmpfaenger';
    xdsEinzelkontaktAbweichenderRechnungsEmpfaenger.FieldName := 'AbweichenderRechnungsEmpfaenger';
    xdsEinzelkontaktAbweichenderRechnungsEmpfaenger.Size := 13;
    xdsEinzelkontaktProtokoll.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktProtokoll.Name := 'xdsEinzelkontaktProtokoll';
    xdsEinzelkontaktProtokoll.FieldName := 'Protokoll';
    xdsEinzelkontaktProtokoll.Size := 255;
    xdsEinzelkontaktILNTyp1.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktILNTyp1.Name := 'xdsEinzelkontaktILNTyp1';
    xdsEinzelkontaktILNTyp1.FieldName := 'ILNTyp1';
    xdsEinzelkontaktILNTyp1.Size := 13;
    xdsEinzelkontaktILNTyp2.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktILNTyp2.Name := 'xdsEinzelkontaktILNTyp2';
    xdsEinzelkontaktILNTyp2.FieldName := 'ILNTyp2';
    xdsEinzelkontaktILNTyp2.Size := 13;
    xdsEinzelkontaktKontaktGUID.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKontaktGUID.Name := 'xdsEinzelkontaktKontaktGUID';
    xdsEinzelkontaktKontaktGUID.FieldName := 'KontaktGUID';
    xdsEinzelkontaktKontaktGUID.Size := 38;
    xdsEinzelkontaktPLZGUID.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktPLZGUID.Name := 'xdsEinzelkontaktPLZGUID';
    xdsEinzelkontaktPLZGUID.FieldName := 'PLZGUID';
    xdsEinzelkontaktPLZGUID.Size := 38;
    xdsEinzelkontaktPreislistenVariantePakete.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktPreislistenVariantePakete.Name := 'xdsEinzelkontaktPreislistenVariantePakete';
    xdsEinzelkontaktPreislistenVariantePakete.FieldName := 'PreislistenVariantePakete';
    xdsEinzelkontaktPreislistenVariantePakete.Size := 50;
    xdsEinzelkontaktSchluesselRechnungslauf.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktSchluesselRechnungslauf.Name := 'xdsEinzelkontaktSchluesselRechnungslauf';
    xdsEinzelkontaktSchluesselRechnungslauf.FieldName := 'SchluesselRechnungslauf';
    xdsEinzelkontaktSchluesselRechnungslauf.Size := 50;
    xdsEinzelkontaktRechnungEmail.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktRechnungEmail.Name := 'xdsEinzelkontaktRechnungEmail';
    xdsEinzelkontaktRechnungEmail.FieldName := 'RechnungEmail';
    xdsEinzelkontaktRechnungEmail.Size := 50;
    xdsEinzelkontaktZahlungsbedingungEK.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktZahlungsbedingungEK.Name := 'xdsEinzelkontaktZahlungsbedingungEK';
    xdsEinzelkontaktZahlungsbedingungEK.FieldName := 'ZahlungsbedingungEK';
    xdsEinzelkontaktTransportbedingungEK.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktTransportbedingungEK.Name := 'xdsEinzelkontaktTransportbedingungEK';
    xdsEinzelkontaktTransportbedingungEK.FieldName := 'TransportbedingungEK';
    xdsEinzelkontaktTransportbedingungEK.Size := 100;
    xdsEinzelkontaktRabattsatzEK.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktRabattsatzEK.Name := 'xdsEinzelkontaktRabattsatzEK';
    xdsEinzelkontaktRabattsatzEK.FieldName := 'RabattsatzEK';
    xdsEinzelkontaktVertreterMatchcode.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktVertreterMatchcode.Name := 'xdsEinzelkontaktVertreterMatchcode';
    xdsEinzelkontaktVertreterMatchcode.FieldName := 'VertreterMatchcode';
    xdsEinzelkontaktVertreterMatchcode.Size := 50;
    xdsEinzelkontaktVertreterProvisionssatz.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktVertreterProvisionssatz.Name := 'xdsEinzelkontaktVertreterProvisionssatz';
    xdsEinzelkontaktVertreterProvisionssatz.FieldName := 'VertreterProvisionssatz';
    xdsEinzelkontaktUmsatzVKJahr.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktUmsatzVKJahr.Name := 'xdsEinzelkontaktUmsatzVKJahr';
    xdsEinzelkontaktUmsatzVKJahr.FieldName := 'UmsatzVKJahr';
    xdsEinzelkontaktUmsatzVKVorjahr.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktUmsatzVKVorjahr.Name := 'xdsEinzelkontaktUmsatzVKVorjahr';
    xdsEinzelkontaktUmsatzVKVorjahr.FieldName := 'UmsatzVKVorjahr';
    xdsEinzelkontaktUmsatzEKJahr.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktUmsatzEKJahr.Name := 'xdsEinzelkontaktUmsatzEKJahr';
    xdsEinzelkontaktUmsatzEKJahr.FieldName := 'UmsatzEKJahr';
    xdsEinzelkontaktUmsatzEKVorjahr.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktUmsatzEKVorjahr.Name := 'xdsEinzelkontaktUmsatzEKVorjahr';
    xdsEinzelkontaktUmsatzEKVorjahr.FieldName := 'UmsatzEKVorjahr';
    xdsEinzelkontaktSteuernummer.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktSteuernummer.Name := 'xdsEinzelkontaktSteuernummer';
    xdsEinzelkontaktSteuernummer.FieldName := 'Steuernummer';
    xdsEinzelkontaktSteuernummer.Size := 25;
    xdsEinzelkontaktLoginPW.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktLoginPW.Name := 'xdsEinzelkontaktLoginPW';
    xdsEinzelkontaktLoginPW.FieldName := 'LoginPW';
    xdsEinzelkontaktREperFax.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktREperFax.Name := 'xdsEinzelkontaktREperFax';
    xdsEinzelkontaktREperFax.FieldName := 'REperFax';
    xdsEinzelkontaktErreichbarkeit.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktErreichbarkeit.Name := 'xdsEinzelkontaktErreichbarkeit';
    xdsEinzelkontaktErreichbarkeit.FieldName := 'Erreichbarkeit';
    xdsEinzelkontaktErreichbarkeit.Size := 250;
    xdsEinzelkontaktErloesKontoUST4.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktErloesKontoUST4.Name := 'xdsEinzelkontaktErloesKontoUST4';
    xdsEinzelkontaktErloesKontoUST4.FieldName := 'ErloesKontoUST4';
    xdsEinzelkontaktErloesKontoUST4.Size := 10;
    xdsEinzelkontaktErloesKontoUST5.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktErloesKontoUST5.Name := 'xdsEinzelkontaktErloesKontoUST5';
    xdsEinzelkontaktErloesKontoUST5.FieldName := 'ErloesKontoUST5';
    xdsEinzelkontaktErloesKontoUST5.Size := 10;
    xdsEinzelkontaktErloesKontoUST6.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktErloesKontoUST6.Name := 'xdsEinzelkontaktErloesKontoUST6';
    xdsEinzelkontaktErloesKontoUST6.FieldName := 'ErloesKontoUST6';
    xdsEinzelkontaktErloesKontoUST6.Size := 10;
    xdsEinzelkontaktBesteuerungKey.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBesteuerungKey.Name := 'xdsEinzelkontaktBesteuerungKey';
    xdsEinzelkontaktBesteuerungKey.FieldName := 'BesteuerungKey';
    xdsEinzelkontaktAuftraegeJahr.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktAuftraegeJahr.Name := 'xdsEinzelkontaktAuftraegeJahr';
    xdsEinzelkontaktAuftraegeJahr.FieldName := 'AuftraegeJahr';
    xdsEinzelkontaktAuftraegeVorjahr.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktAuftraegeVorjahr.Name := 'xdsEinzelkontaktAuftraegeVorjahr';
    xdsEinzelkontaktAuftraegeVorjahr.FieldName := 'AuftraegeVorjahr';
    xdsEinzelkontaktLieferadresseID.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktLieferadresseID.Name := 'xdsEinzelkontaktLieferadresseID';
    xdsEinzelkontaktLieferadresseID.FieldName := 'LieferadresseID';
    xdsEinzelkontaktUSTIDgeprueft.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktUSTIDgeprueft.Name := 'xdsEinzelkontaktUSTIDgeprueft';
    xdsEinzelkontaktUSTIDgeprueft.FieldName := 'USTIDgeprueft';
    xdsEinzelkontaktKontaktverbund.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktKontaktverbund.Name := 'xdsEinzelkontaktKontaktverbund';
    xdsEinzelkontaktKontaktverbund.FieldName := 'Kontaktverbund';
    xdsEinzelkontaktKontaktverbund.Size := 25;
    xdsEinzelkontaktHinweis.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktHinweis.Name := 'xdsEinzelkontaktHinweis';
    xdsEinzelkontaktHinweis.FieldName := 'Hinweis';
    xdsEinzelkontaktHinweis.Size := 255;
    xdsEinzelkontaktLatitude.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktLatitude.Name := 'xdsEinzelkontaktLatitude';
    xdsEinzelkontaktLatitude.FieldName := 'Latitude';
    xdsEinzelkontaktLongitude.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktLongitude.Name := 'xdsEinzelkontaktLongitude';
    xdsEinzelkontaktLongitude.FieldName := 'Longitude';
    xdsEinzelkontaktkmLuftlinie.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktkmLuftlinie.Name := 'xdsEinzelkontaktkmLuftlinie';
    xdsEinzelkontaktkmLuftlinie.FieldName := 'kmLuftlinie';
    xdsEinzelkontaktGoogleID.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktGoogleID.Name := 'xdsEinzelkontaktGoogleID';
    xdsEinzelkontaktGoogleID.FieldName := 'GoogleID';
    xdsEinzelkontaktGoogleID.Size := 50;
    xdsEinzelkontaktGoogleUpdatedUTC.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktGoogleUpdatedUTC.Name := 'xdsEinzelkontaktGoogleUpdatedUTC';
    xdsEinzelkontaktGoogleUpdatedUTC.FieldName := 'GoogleUpdatedUTC';
    xdsEinzelkontaktBundesland.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktBundesland.Name := 'xdsEinzelkontaktBundesland';
    xdsEinzelkontaktBundesland.FieldName := 'Bundesland';
    xdsEinzelkontaktBundesland.Size := 50;
    xdsEinzelkontaktRegion.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktRegion.Name := 'xdsEinzelkontaktRegion';
    xdsEinzelkontaktRegion.FieldName := 'Region';
    xdsEinzelkontaktRegion.Size := 50;
    xdsEinzelkontaktMandatsreferenz.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktMandatsreferenz.Name := 'xdsEinzelkontaktMandatsreferenz';
    xdsEinzelkontaktMandatsreferenz.FieldName := 'Mandatsreferenz';
    xdsEinzelkontaktMandatsreferenz.Size := 34;
    xdsEinzelkontaktMandatsreferenzVom.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktMandatsreferenzVom.Name := 'xdsEinzelkontaktMandatsreferenzVom';
    xdsEinzelkontaktMandatsreferenzVom.FieldName := 'MandatsreferenzVom';
    xdsEinzelkontaktLastschriftArt.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktLastschriftArt.Name := 'xdsEinzelkontaktLastschriftArt';
    xdsEinzelkontaktLastschriftArt.FieldName := 'LastschriftArt';
    xdsEinzelkontaktLastschriftArt.Size := 2;
    xdsEinzelkontaktMahnsperre.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktMahnsperre.Name := 'xdsEinzelkontaktMahnsperre';
    xdsEinzelkontaktMahnsperre.FieldName := 'Mahnsperre';
    xdsEinzelkontaktSuchbegriff.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktSuchbegriff.Name := 'xdsEinzelkontaktSuchbegriff';
    xdsEinzelkontaktSuchbegriff.FieldName := 'Suchbegriff';
    xdsEinzelkontaktSuchbegriff.Size := 25;
    xdsEinzelkontaktLieferanschriftDaten.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktLieferanschriftDaten.Name := 'xdsEinzelkontaktLieferanschriftDaten';
    xdsEinzelkontaktLieferanschriftDaten.FieldName := 'LieferanschriftDaten';
    xdsEinzelkontaktLieferanschriftDaten.Size := 255;
    xdsEinzelkontaktExportKasse.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktExportKasse.Name := 'xdsEinzelkontaktExportKasse';
    xdsEinzelkontaktExportKasse.FieldName := 'ExportKasse';
    xdsEinzelkontaktLoeschvormerkungDatum.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktLoeschvormerkungDatum.Name := 'xdsEinzelkontaktLoeschvormerkungDatum';
    xdsEinzelkontaktLoeschvormerkungDatum.FieldName := 'LoeschvormerkungDatum';
    xdsEinzelkontaktLoeschvormerkungGrund.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktLoeschvormerkungGrund.Name := 'xdsEinzelkontaktLoeschvormerkungGrund';
    xdsEinzelkontaktLoeschvormerkungGrund.FieldName := 'LoeschvormerkungGrund';
    xdsEinzelkontaktLoeschvormerkungGrund.Size := 250;
    xdsEinzelkontaktPseudonymisiert.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktPseudonymisiert.Name := 'xdsEinzelkontaktPseudonymisiert';
    xdsEinzelkontaktPseudonymisiert.FieldName := 'Pseudonymisiert';
    xdsEinzelkontaktPseudonymisiert.Size := 255;
    xdsEinzelkontaktLoginAktiv.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktLoginAktiv.Name := 'xdsEinzelkontaktLoginAktiv';
    xdsEinzelkontaktLoginAktiv.FieldName := 'LoginAktiv';
    xdsEinzelkontaktSonstigeDaten.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktSonstigeDaten.Name := 'xdsEinzelkontaktSonstigeDaten';
    xdsEinzelkontaktSonstigeDaten.FieldName := 'SonstigeDaten';
    xdsEinzelkontaktSonstigeDaten.Size := 255;
    xdsEinzelkontaktB2C.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktB2C.Name := 'xdsEinzelkontaktB2C';
    xdsEinzelkontaktB2C.FieldName := 'B2C';
    xdsEinzelkontaktTIN.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktTIN.Name := 'xdsEinzelkontaktTIN';
    xdsEinzelkontaktTIN.FieldName := 'TIN';
    xdsEinzelkontaktTIN.Size := 25;
    xdsEinzelkontaktMindestbestellwert.SetParentComponent(xdsEinzelkontakt);
    xdsEinzelkontaktMindestbestellwert.Name := 'xdsEinzelkontaktMindestbestellwert';
    xdsEinzelkontaktMindestbestellwert.FieldName := 'Mindestbestellwert';
    xdsLaender.SetParentComponent(Self);
    xdsLaender.Name := 'xdsLaender';
    xdsLaender.AfterOpen := xdsLaenderAfterOpen;
    xdsLaender.EntitySetName := 'Laender';
    xdsLaender.Connection := DM2.XDataWebConnection1;
    xdsLaender.QueryString := '$OrderBy=Land';
    xdsLaender.Left := 260;
    xdsLaender.Top := 349;
    xdsLaenderLaenderkuerzel.SetParentComponent(xdsLaender);
    xdsLaenderLaenderkuerzel.Name := 'xdsLaenderLaenderkuerzel';
    xdsLaenderLaenderkuerzel.FieldName := 'Laenderkuerzel';
    xdsLaenderLaenderkuerzel.Required := True;
    xdsLaenderLaenderkuerzel.Size := 5;
    xdsLaenderLand.SetParentComponent(xdsLaender);
    xdsLaenderLand.Name := 'xdsLaenderLand';
    xdsLaenderLand.FieldName := 'Land';
    sourceLaender.SetParentComponent(Self);
    sourceLaender.Name := 'sourceLaender';
    sourceLaender.DataSet := xdsLaender;
    sourceLaender.Left := 260;
    sourceLaender.Top := 293;
    xdsBestKey.SetParentComponent(Self);
    xdsBestKey.Name := 'xdsBestKey';
    xdsBestKey.AfterOpen := xdsBestKeyAfterOpen;
    xdsBestKey.EntitySetName := 'MWStBesteuerung';
    xdsBestKey.Connection := DM2.XDataWebConnection1;
    xdsBestKey.Left := 260;
    xdsBestKey.Top := 77;
    xdsBestKeyBesteuerungKey.SetParentComponent(xdsBestKey);
    xdsBestKeyBesteuerungKey.Name := 'xdsBestKeyBesteuerungKey';
    xdsBestKeyBesteuerungKey.FieldName := 'BesteuerungKey';
    xdsBestKeyBesteuerungKey.Required := True;
    xdsBestKeyBesteuerungKurzText.SetParentComponent(xdsBestKey);
    xdsBestKeyBesteuerungKurzText.Name := 'xdsBestKeyBesteuerungKurzText';
    xdsBestKeyBesteuerungKurzText.FieldName := 'BesteuerungKurzText';
    xdsBestKeyBesteuerungKurzText.Size := 50;
    xdsBestKeyBesteuerungLangText.SetParentComponent(xdsBestKey);
    xdsBestKeyBesteuerungLangText.Name := 'xdsBestKeyBesteuerungLangText';
    xdsBestKeyBesteuerungLangText.FieldName := 'BesteuerungLangText';
    xdsBestKeyBesteuerungLangText.Size := 255;
    xdsBestKeyUmsatzsteuerausweis.SetParentComponent(xdsBestKey);
    xdsBestKeyUmsatzsteuerausweis.Name := 'xdsBestKeyUmsatzsteuerausweis';
    xdsBestKeyUmsatzsteuerausweis.FieldName := 'Umsatzsteuerausweis';
    xdsBestKeyKtoVorsteuerSatz1.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoVorsteuerSatz1.Name := 'xdsBestKeyKtoVorsteuerSatz1';
    xdsBestKeyKtoVorsteuerSatz1.FieldName := 'KtoVorsteuerSatz1';
    xdsBestKeyKtoVorsteuerSatz2.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoVorsteuerSatz2.Name := 'xdsBestKeyKtoVorsteuerSatz2';
    xdsBestKeyKtoVorsteuerSatz2.FieldName := 'KtoVorsteuerSatz2';
    xdsBestKeyKtoVorsteuerSatz3.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoVorsteuerSatz3.Name := 'xdsBestKeyKtoVorsteuerSatz3';
    xdsBestKeyKtoVorsteuerSatz3.FieldName := 'KtoVorsteuerSatz3';
    xdsBestKeyKtoVorsteuerSatz4.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoVorsteuerSatz4.Name := 'xdsBestKeyKtoVorsteuerSatz4';
    xdsBestKeyKtoVorsteuerSatz4.FieldName := 'KtoVorsteuerSatz4';
    xdsBestKeyKtoVorsteuerSatz5.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoVorsteuerSatz5.Name := 'xdsBestKeyKtoVorsteuerSatz5';
    xdsBestKeyKtoVorsteuerSatz5.FieldName := 'KtoVorsteuerSatz5';
    xdsBestKeyKtoVorsteuerSatz6.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoVorsteuerSatz6.Name := 'xdsBestKeyKtoVorsteuerSatz6';
    xdsBestKeyKtoVorsteuerSatz6.FieldName := 'KtoVorsteuerSatz6';
    xdsBestKeyKtoErloeseSatz1.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoErloeseSatz1.Name := 'xdsBestKeyKtoErloeseSatz1';
    xdsBestKeyKtoErloeseSatz1.FieldName := 'KtoErloeseSatz1';
    xdsBestKeyKtoErloeseSatz2.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoErloeseSatz2.Name := 'xdsBestKeyKtoErloeseSatz2';
    xdsBestKeyKtoErloeseSatz2.FieldName := 'KtoErloeseSatz2';
    xdsBestKeyKtoErloeseSatz3.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoErloeseSatz3.Name := 'xdsBestKeyKtoErloeseSatz3';
    xdsBestKeyKtoErloeseSatz3.FieldName := 'KtoErloeseSatz3';
    xdsBestKeyKtoErloeseSatz4.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoErloeseSatz4.Name := 'xdsBestKeyKtoErloeseSatz4';
    xdsBestKeyKtoErloeseSatz4.FieldName := 'KtoErloeseSatz4';
    xdsBestKeyKtoErloeseSatz5.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoErloeseSatz5.Name := 'xdsBestKeyKtoErloeseSatz5';
    xdsBestKeyKtoErloeseSatz5.FieldName := 'KtoErloeseSatz5';
    xdsBestKeyKtoErloeseSatz6.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoErloeseSatz6.Name := 'xdsBestKeyKtoErloeseSatz6';
    xdsBestKeyKtoErloeseSatz6.FieldName := 'KtoErloeseSatz6';
    xdsBestKeyKtoSkontoaufwandSatz1.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoSkontoaufwandSatz1.Name := 'xdsBestKeyKtoSkontoaufwandSatz1';
    xdsBestKeyKtoSkontoaufwandSatz1.FieldName := 'KtoSkontoaufwandSatz1';
    xdsBestKeyKtoSkontoaufwandSatz2.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoSkontoaufwandSatz2.Name := 'xdsBestKeyKtoSkontoaufwandSatz2';
    xdsBestKeyKtoSkontoaufwandSatz2.FieldName := 'KtoSkontoaufwandSatz2';
    xdsBestKeyKtoSkontoaufwandSatz3.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoSkontoaufwandSatz3.Name := 'xdsBestKeyKtoSkontoaufwandSatz3';
    xdsBestKeyKtoSkontoaufwandSatz3.FieldName := 'KtoSkontoaufwandSatz3';
    xdsBestKeyKtoSkontoaufwandSatz4.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoSkontoaufwandSatz4.Name := 'xdsBestKeyKtoSkontoaufwandSatz4';
    xdsBestKeyKtoSkontoaufwandSatz4.FieldName := 'KtoSkontoaufwandSatz4';
    xdsBestKeyKtoSkontoaufwandSatz5.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoSkontoaufwandSatz5.Name := 'xdsBestKeyKtoSkontoaufwandSatz5';
    xdsBestKeyKtoSkontoaufwandSatz5.FieldName := 'KtoSkontoaufwandSatz5';
    xdsBestKeyKtoSkontoaufwandSatz6.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoSkontoaufwandSatz6.Name := 'xdsBestKeyKtoSkontoaufwandSatz6';
    xdsBestKeyKtoSkontoaufwandSatz6.FieldName := 'KtoSkontoaufwandSatz6';
    xdsBestKeyKtoSkontoertragSatz1.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoSkontoertragSatz1.Name := 'xdsBestKeyKtoSkontoertragSatz1';
    xdsBestKeyKtoSkontoertragSatz1.FieldName := 'KtoSkontoertragSatz1';
    xdsBestKeyKtoSkontoertragSatz2.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoSkontoertragSatz2.Name := 'xdsBestKeyKtoSkontoertragSatz2';
    xdsBestKeyKtoSkontoertragSatz2.FieldName := 'KtoSkontoertragSatz2';
    xdsBestKeyKtoSkontoertragSatz3.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoSkontoertragSatz3.Name := 'xdsBestKeyKtoSkontoertragSatz3';
    xdsBestKeyKtoSkontoertragSatz3.FieldName := 'KtoSkontoertragSatz3';
    xdsBestKeyKtoSkontoertragSatz4.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoSkontoertragSatz4.Name := 'xdsBestKeyKtoSkontoertragSatz4';
    xdsBestKeyKtoSkontoertragSatz4.FieldName := 'KtoSkontoertragSatz4';
    xdsBestKeyKtoSkontoertragSatz5.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoSkontoertragSatz5.Name := 'xdsBestKeyKtoSkontoertragSatz5';
    xdsBestKeyKtoSkontoertragSatz5.FieldName := 'KtoSkontoertragSatz5';
    xdsBestKeyKtoSkontoertragSatz6.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoSkontoertragSatz6.Name := 'xdsBestKeyKtoSkontoertragSatz6';
    xdsBestKeyKtoSkontoertragSatz6.FieldName := 'KtoSkontoertragSatz6';
    xdsBestKeyKtoErloesschmaelerungenSatz1.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoErloesschmaelerungenSatz1.Name := 'xdsBestKeyKtoErloesschmaelerungenSatz1';
    xdsBestKeyKtoErloesschmaelerungenSatz1.FieldName := 'KtoErloesschmaelerungenSatz1';
    xdsBestKeyKtoErloesschmaelerungenSatz2.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoErloesschmaelerungenSatz2.Name := 'xdsBestKeyKtoErloesschmaelerungenSatz2';
    xdsBestKeyKtoErloesschmaelerungenSatz2.FieldName := 'KtoErloesschmaelerungenSatz2';
    xdsBestKeyKtoErloesschmaelerungenSatz3.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoErloesschmaelerungenSatz3.Name := 'xdsBestKeyKtoErloesschmaelerungenSatz3';
    xdsBestKeyKtoErloesschmaelerungenSatz3.FieldName := 'KtoErloesschmaelerungenSatz3';
    xdsBestKeyKtoErloesschmaelerungenSatz4.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoErloesschmaelerungenSatz4.Name := 'xdsBestKeyKtoErloesschmaelerungenSatz4';
    xdsBestKeyKtoErloesschmaelerungenSatz4.FieldName := 'KtoErloesschmaelerungenSatz4';
    xdsBestKeyKtoErloesschmaelerungenSatz5.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoErloesschmaelerungenSatz5.Name := 'xdsBestKeyKtoErloesschmaelerungenSatz5';
    xdsBestKeyKtoErloesschmaelerungenSatz5.FieldName := 'KtoErloesschmaelerungenSatz5';
    xdsBestKeyKtoErloesschmaelerungenSatz6.SetParentComponent(xdsBestKey);
    xdsBestKeyKtoErloesschmaelerungenSatz6.Name := 'xdsBestKeyKtoErloesschmaelerungenSatz6';
    xdsBestKeyKtoErloesschmaelerungenSatz6.FieldName := 'KtoErloesschmaelerungenSatz6';
    xdsBestKeyNatura.SetParentComponent(xdsBestKey);
    xdsBestKeyNatura.Name := 'xdsBestKeyNatura';
    xdsBestKeyNatura.FieldName := 'Natura';
    xdsBestKeyNatura.Size := 5;
    xdsBestKeyBSchl_UST_Satz1.SetParentComponent(xdsBestKey);
    xdsBestKeyBSchl_UST_Satz1.Name := 'xdsBestKeyBSchl_UST_Satz1';
    xdsBestKeyBSchl_UST_Satz1.FieldName := 'BSchl_UST_Satz1';
    xdsBestKeyBSchl_UST_Satz2.SetParentComponent(xdsBestKey);
    xdsBestKeyBSchl_UST_Satz2.Name := 'xdsBestKeyBSchl_UST_Satz2';
    xdsBestKeyBSchl_UST_Satz2.FieldName := 'BSchl_UST_Satz2';
    xdsBestKeyBSchl_UST_Satz3.SetParentComponent(xdsBestKey);
    xdsBestKeyBSchl_UST_Satz3.Name := 'xdsBestKeyBSchl_UST_Satz3';
    xdsBestKeyBSchl_UST_Satz3.FieldName := 'BSchl_UST_Satz3';
    xdsBestKeyBSchl_UST_Satz4.SetParentComponent(xdsBestKey);
    xdsBestKeyBSchl_UST_Satz4.Name := 'xdsBestKeyBSchl_UST_Satz4';
    xdsBestKeyBSchl_UST_Satz4.FieldName := 'BSchl_UST_Satz4';
    xdsBestKeyBSchl_UST_Satz5.SetParentComponent(xdsBestKey);
    xdsBestKeyBSchl_UST_Satz5.Name := 'xdsBestKeyBSchl_UST_Satz5';
    xdsBestKeyBSchl_UST_Satz5.FieldName := 'BSchl_UST_Satz5';
    xdsBestKeyBSchl_UST_Satz6.SetParentComponent(xdsBestKey);
    xdsBestKeyBSchl_UST_Satz6.Name := 'xdsBestKeyBSchl_UST_Satz6';
    xdsBestKeyBSchl_UST_Satz6.FieldName := 'BSchl_UST_Satz6';
    xdsBestKeyBSchl_Vorsteuer_Satz1.SetParentComponent(xdsBestKey);
    xdsBestKeyBSchl_Vorsteuer_Satz1.Name := 'xdsBestKeyBSchl_Vorsteuer_Satz1';
    xdsBestKeyBSchl_Vorsteuer_Satz1.FieldName := 'BSchl_Vorsteuer_Satz1';
    xdsBestKeyBSchl_Vorsteuer_Satz2.SetParentComponent(xdsBestKey);
    xdsBestKeyBSchl_Vorsteuer_Satz2.Name := 'xdsBestKeyBSchl_Vorsteuer_Satz2';
    xdsBestKeyBSchl_Vorsteuer_Satz2.FieldName := 'BSchl_Vorsteuer_Satz2';
    xdsBestKeyBSchl_Vorsteuer_Satz3.SetParentComponent(xdsBestKey);
    xdsBestKeyBSchl_Vorsteuer_Satz3.Name := 'xdsBestKeyBSchl_Vorsteuer_Satz3';
    xdsBestKeyBSchl_Vorsteuer_Satz3.FieldName := 'BSchl_Vorsteuer_Satz3';
    xdsBestKeyBSchl_Vorsteuer_Satz4.SetParentComponent(xdsBestKey);
    xdsBestKeyBSchl_Vorsteuer_Satz4.Name := 'xdsBestKeyBSchl_Vorsteuer_Satz4';
    xdsBestKeyBSchl_Vorsteuer_Satz4.FieldName := 'BSchl_Vorsteuer_Satz4';
    xdsBestKeyBSchl_Vorsteuer_Satz5.SetParentComponent(xdsBestKey);
    xdsBestKeyBSchl_Vorsteuer_Satz5.Name := 'xdsBestKeyBSchl_Vorsteuer_Satz5';
    xdsBestKeyBSchl_Vorsteuer_Satz5.FieldName := 'BSchl_Vorsteuer_Satz5';
    xdsBestKeyBSchl_Vorsteuer_Satz6.SetParentComponent(xdsBestKey);
    xdsBestKeyBSchl_Vorsteuer_Satz6.Name := 'xdsBestKeyBSchl_Vorsteuer_Satz6';
    xdsBestKeyBSchl_Vorsteuer_Satz6.FieldName := 'BSchl_Vorsteuer_Satz6';
    xdsBestKeyDokTyp.SetParentComponent(xdsBestKey);
    xdsBestKeyDokTyp.Name := 'xdsBestKeyDokTyp';
    xdsBestKeyDokTyp.FieldName := 'DokTyp';
    xdsBestKeyDokTyp.Size := 5;
    sourceBestKey.SetParentComponent(Self);
    sourceBestKey.Name := 'sourceBestKey';
    sourceBestKey.DataSet := xdsBestKey;
    sourceBestKey.Left := 260;
    sourceBestKey.Top := 21;
  finally
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    TC.AfterLoadDFMValues;
    edtStrasse.AfterLoadDFMValues;
    edtPostleitzahl.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    btnSpeichern.AfterLoadDFMValues;
    edtVorname.AfterLoadDFMValues;
    edtAdresszeile2.AfterLoadDFMValues;
    edtAdresszeile3.AfterLoadDFMValues;
    edtOrt.AfterLoadDFMValues;
    edtLand.AfterLoadDFMValues;
    edtTelefon.AfterLoadDFMValues;
    edtTelefonAlternativ.AfterLoadDFMValues;
    edtTelefonMobil.AfterLoadDFMValues;
    edtInternet.AfterLoadDFMValues;
    edtEmail.AfterLoadDFMValues;
    edtAdressanrede.AfterLoadDFMValues;
    edtTitel.AfterLoadDFMValues;
    edtNachname.AfterLoadDFMValues;
    sourceEinzelkontakt.AfterLoadDFMValues;
    xdsEinzelkontakt.AfterLoadDFMValues;
    xdsEinzelkontaktKundennummer.AfterLoadDFMValues;
    xdsEinzelkontaktGruppeKunden.AfterLoadDFMValues;
    xdsEinzelkontaktGruppeLieferanten.AfterLoadDFMValues;
    xdsEinzelkontaktGruppeSonstige.AfterLoadDFMValues;
    xdsEinzelkontaktGruppeNichtkunden.AfterLoadDFMValues;
    xdsEinzelkontaktKontaktgruppe.AfterLoadDFMValues;
    xdsEinzelkontaktNachname.AfterLoadDFMValues;
    xdsEinzelkontaktVorname.AfterLoadDFMValues;
    xdsEinzelkontaktAdresszeile2.AfterLoadDFMValues;
    xdsEinzelkontaktAdresszeile3.AfterLoadDFMValues;
    xdsEinzelkontaktStrasse.AfterLoadDFMValues;
    xdsEinzelkontaktPostleitzahl.AfterLoadDFMValues;
    xdsEinzelkontaktOrt.AfterLoadDFMValues;
    xdsEinzelkontaktLaenderkuerzel.AfterLoadDFMValues;
    xdsEinzelkontaktLand.AfterLoadDFMValues;
    xdsEinzelkontaktLaenderkennzeichen.AfterLoadDFMValues;
    xdsEinzelkontaktAdressanrede.AfterLoadDFMValues;
    xdsEinzelkontaktBriefanrede1.AfterLoadDFMValues;
    xdsEinzelkontaktBriefanrede2.AfterLoadDFMValues;
    xdsEinzelkontaktAdresseBild.AfterLoadDFMValues;
    xdsEinzelkontaktLieferanschrift.AfterLoadDFMValues;
    xdsEinzelkontaktGeburtsdatum.AfterLoadDFMValues;
    xdsEinzelkontaktTelefonNummer.AfterLoadDFMValues;
    xdsEinzelkontaktTelefaxNummer.AfterLoadDFMValues;
    xdsEinzelkontaktMobilTelefon.AfterLoadDFMValues;
    xdsEinzelkontaktEMail.AfterLoadDFMValues;
    xdsEinzelkontaktInternet.AfterLoadDFMValues;
    xdsEinzelkontaktUmsatzsteuerID.AfterLoadDFMValues;
    xdsEinzelkontaktUmsatzsteuerausweis.AfterLoadDFMValues;
    xdsEinzelkontaktBemerkungen.AfterLoadDFMValues;
    xdsEinzelkontaktBranche.AfterLoadDFMValues;
    xdsEinzelkontaktSelektiert1.AfterLoadDFMValues;
    xdsEinzelkontaktSelektiert2.AfterLoadDFMValues;
    xdsEinzelkontaktSelektiert3.AfterLoadDFMValues;
    xdsEinzelkontaktZahlungsbedingung.AfterLoadDFMValues;
    xdsEinzelkontaktTransportbedingung.AfterLoadDFMValues;
    xdsEinzelkontaktKilometer.AfterLoadDFMValues;
    xdsEinzelkontaktRabattsatz.AfterLoadDFMValues;
    xdsEinzelkontaktStundensatz.AfterLoadDFMValues;
    xdsEinzelkontaktKontonummer.AfterLoadDFMValues;
    xdsEinzelkontaktBank.AfterLoadDFMValues;
    xdsEinzelkontaktBankleitzahl.AfterLoadDFMValues;
    xdsEinzelkontaktKontoinhaber.AfterLoadDFMValues;
    xdsEinzelkontaktBetreuer.AfterLoadDFMValues;
    xdsEinzelkontaktQuelle.AfterLoadDFMValues;
    xdsEinzelkontaktSuchmerkmal.AfterLoadDFMValues;
    xdsEinzelkontaktWarenkreditlimit.AfterLoadDFMValues;
    xdsEinzelkontaktWarenkreditgesperrt.AfterLoadDFMValues;
    xdsEinzelkontaktKundennummerFremd.AfterLoadDFMValues;
    xdsEinzelkontaktKeinNewsletter.AfterLoadDFMValues;
    xdsEinzelkontaktDebitorennummer.AfterLoadDFMValues;
    xdsEinzelkontaktKreditorennummer.AfterLoadDFMValues;
    xdsEinzelkontaktTelefonAlternativ.AfterLoadDFMValues;
    xdsEinzelkontaktKostentraeger.AfterLoadDFMValues;
    xdsEinzelkontaktIBAN.AfterLoadDFMValues;
    xdsEinzelkontaktBIC.AfterLoadDFMValues;
    xdsEinzelkontaktEmailkonto.AfterLoadDFMValues;
    xdsEinzelkontaktBenutzername.AfterLoadDFMValues;
    xdsEinzelkontaktPasswort.AfterLoadDFMValues;
    xdsEinzelkontaktExportOutlook.AfterLoadDFMValues;
    xdsEinzelkontaktNichtInListeAnzeigen.AfterLoadDFMValues;
    xdsEinzelkontaktKreditkarteArt.AfterLoadDFMValues;
    xdsEinzelkontaktKreditkarteInhaber.AfterLoadDFMValues;
    xdsEinzelkontaktKreditkarteNummer.AfterLoadDFMValues;
    xdsEinzelkontaktKreditkarteGueltigMonat.AfterLoadDFMValues;
    xdsEinzelkontaktKreditkarteGueltigJahr.AfterLoadDFMValues;
    xdsEinzelkontaktKreditkartePruefziffer.AfterLoadDFMValues;
    xdsEinzelkontaktDatumNeu.AfterLoadDFMValues;
    xdsEinzelkontaktDatumgeaendert.AfterLoadDFMValues;
    xdsEinzelkontaktTitel.AfterLoadDFMValues;
    xdsEinzelkontaktStundensatzMontage.AfterLoadDFMValues;
    xdsEinzelkontaktStdMontageU25.AfterLoadDFMValues;
    xdsEinzelkontaktStdMontageU50.AfterLoadDFMValues;
    xdsEinzelkontaktStdMontageU70.AfterLoadDFMValues;
    xdsEinzelkontaktStdMontageU100.AfterLoadDFMValues;
    xdsEinzelkontaktStdMontageU150.AfterLoadDFMValues;
    xdsEinzelkontaktStundensatzWerkstatt.AfterLoadDFMValues;
    xdsEinzelkontaktStdWerkstattU25.AfterLoadDFMValues;
    xdsEinzelkontaktStdWerkstattU50.AfterLoadDFMValues;
    xdsEinzelkontaktStdWerkstattU70.AfterLoadDFMValues;
    xdsEinzelkontaktStdWerkstattU100.AfterLoadDFMValues;
    xdsEinzelkontaktStdWerkstattU150.AfterLoadDFMValues;
    xdsEinzelkontaktArchivReferenz.AfterLoadDFMValues;
    xdsEinzelkontaktErloesKontoUST1.AfterLoadDFMValues;
    xdsEinzelkontaktErloesKontoUST2.AfterLoadDFMValues;
    xdsEinzelkontaktErloesKontoUST3.AfterLoadDFMValues;
    xdsEinzelkontaktGebKal.AfterLoadDFMValues;
    xdsEinzelkontaktEmailversand.AfterLoadDFMValues;
    xdsEinzelkontaktMahnspesen.AfterLoadDFMValues;
    xdsEinzelkontaktRechnungSchluss.AfterLoadDFMValues;
    xdsEinzelkontaktBenutzerNeu.AfterLoadDFMValues;
    xdsEinzelkontaktBenutzerGeaendert.AfterLoadDFMValues;
    xdsEinzelkontaktBelegsprache.AfterLoadDFMValues;
    xdsEinzelkontaktkmSatz.AfterLoadDFMValues;
    xdsEinzelkontaktKundenklassetext.AfterLoadDFMValues;
    xdsEinzelkontaktKundenklasseFarbe.AfterLoadDFMValues;
    xdsEinzelkontaktAbweichenderRechnungsEmpfaenger.AfterLoadDFMValues;
    xdsEinzelkontaktProtokoll.AfterLoadDFMValues;
    xdsEinzelkontaktILNTyp1.AfterLoadDFMValues;
    xdsEinzelkontaktILNTyp2.AfterLoadDFMValues;
    xdsEinzelkontaktKontaktGUID.AfterLoadDFMValues;
    xdsEinzelkontaktPLZGUID.AfterLoadDFMValues;
    xdsEinzelkontaktPreislistenVariantePakete.AfterLoadDFMValues;
    xdsEinzelkontaktSchluesselRechnungslauf.AfterLoadDFMValues;
    xdsEinzelkontaktRechnungEmail.AfterLoadDFMValues;
    xdsEinzelkontaktZahlungsbedingungEK.AfterLoadDFMValues;
    xdsEinzelkontaktTransportbedingungEK.AfterLoadDFMValues;
    xdsEinzelkontaktRabattsatzEK.AfterLoadDFMValues;
    xdsEinzelkontaktVertreterMatchcode.AfterLoadDFMValues;
    xdsEinzelkontaktVertreterProvisionssatz.AfterLoadDFMValues;
    xdsEinzelkontaktUmsatzVKJahr.AfterLoadDFMValues;
    xdsEinzelkontaktUmsatzVKVorjahr.AfterLoadDFMValues;
    xdsEinzelkontaktUmsatzEKJahr.AfterLoadDFMValues;
    xdsEinzelkontaktUmsatzEKVorjahr.AfterLoadDFMValues;
    xdsEinzelkontaktSteuernummer.AfterLoadDFMValues;
    xdsEinzelkontaktLoginPW.AfterLoadDFMValues;
    xdsEinzelkontaktREperFax.AfterLoadDFMValues;
    xdsEinzelkontaktErreichbarkeit.AfterLoadDFMValues;
    xdsEinzelkontaktErloesKontoUST4.AfterLoadDFMValues;
    xdsEinzelkontaktErloesKontoUST5.AfterLoadDFMValues;
    xdsEinzelkontaktErloesKontoUST6.AfterLoadDFMValues;
    xdsEinzelkontaktBesteuerungKey.AfterLoadDFMValues;
    xdsEinzelkontaktAuftraegeJahr.AfterLoadDFMValues;
    xdsEinzelkontaktAuftraegeVorjahr.AfterLoadDFMValues;
    xdsEinzelkontaktLieferadresseID.AfterLoadDFMValues;
    xdsEinzelkontaktUSTIDgeprueft.AfterLoadDFMValues;
    xdsEinzelkontaktKontaktverbund.AfterLoadDFMValues;
    xdsEinzelkontaktHinweis.AfterLoadDFMValues;
    xdsEinzelkontaktLatitude.AfterLoadDFMValues;
    xdsEinzelkontaktLongitude.AfterLoadDFMValues;
    xdsEinzelkontaktkmLuftlinie.AfterLoadDFMValues;
    xdsEinzelkontaktGoogleID.AfterLoadDFMValues;
    xdsEinzelkontaktGoogleUpdatedUTC.AfterLoadDFMValues;
    xdsEinzelkontaktBundesland.AfterLoadDFMValues;
    xdsEinzelkontaktRegion.AfterLoadDFMValues;
    xdsEinzelkontaktMandatsreferenz.AfterLoadDFMValues;
    xdsEinzelkontaktMandatsreferenzVom.AfterLoadDFMValues;
    xdsEinzelkontaktLastschriftArt.AfterLoadDFMValues;
    xdsEinzelkontaktMahnsperre.AfterLoadDFMValues;
    xdsEinzelkontaktSuchbegriff.AfterLoadDFMValues;
    xdsEinzelkontaktLieferanschriftDaten.AfterLoadDFMValues;
    xdsEinzelkontaktExportKasse.AfterLoadDFMValues;
    xdsEinzelkontaktLoeschvormerkungDatum.AfterLoadDFMValues;
    xdsEinzelkontaktLoeschvormerkungGrund.AfterLoadDFMValues;
    xdsEinzelkontaktPseudonymisiert.AfterLoadDFMValues;
    xdsEinzelkontaktLoginAktiv.AfterLoadDFMValues;
    xdsEinzelkontaktSonstigeDaten.AfterLoadDFMValues;
    xdsEinzelkontaktB2C.AfterLoadDFMValues;
    xdsEinzelkontaktTIN.AfterLoadDFMValues;
    xdsEinzelkontaktMindestbestellwert.AfterLoadDFMValues;
    xdsLaender.AfterLoadDFMValues;
    xdsLaenderLaenderkuerzel.AfterLoadDFMValues;
    xdsLaenderLand.AfterLoadDFMValues;
    sourceLaender.AfterLoadDFMValues;
    xdsBestKey.AfterLoadDFMValues;
    xdsBestKeyBesteuerungKey.AfterLoadDFMValues;
    xdsBestKeyBesteuerungKurzText.AfterLoadDFMValues;
    xdsBestKeyBesteuerungLangText.AfterLoadDFMValues;
    xdsBestKeyUmsatzsteuerausweis.AfterLoadDFMValues;
    xdsBestKeyKtoVorsteuerSatz1.AfterLoadDFMValues;
    xdsBestKeyKtoVorsteuerSatz2.AfterLoadDFMValues;
    xdsBestKeyKtoVorsteuerSatz3.AfterLoadDFMValues;
    xdsBestKeyKtoVorsteuerSatz4.AfterLoadDFMValues;
    xdsBestKeyKtoVorsteuerSatz5.AfterLoadDFMValues;
    xdsBestKeyKtoVorsteuerSatz6.AfterLoadDFMValues;
    xdsBestKeyKtoErloeseSatz1.AfterLoadDFMValues;
    xdsBestKeyKtoErloeseSatz2.AfterLoadDFMValues;
    xdsBestKeyKtoErloeseSatz3.AfterLoadDFMValues;
    xdsBestKeyKtoErloeseSatz4.AfterLoadDFMValues;
    xdsBestKeyKtoErloeseSatz5.AfterLoadDFMValues;
    xdsBestKeyKtoErloeseSatz6.AfterLoadDFMValues;
    xdsBestKeyKtoSkontoaufwandSatz1.AfterLoadDFMValues;
    xdsBestKeyKtoSkontoaufwandSatz2.AfterLoadDFMValues;
    xdsBestKeyKtoSkontoaufwandSatz3.AfterLoadDFMValues;
    xdsBestKeyKtoSkontoaufwandSatz4.AfterLoadDFMValues;
    xdsBestKeyKtoSkontoaufwandSatz5.AfterLoadDFMValues;
    xdsBestKeyKtoSkontoaufwandSatz6.AfterLoadDFMValues;
    xdsBestKeyKtoSkontoertragSatz1.AfterLoadDFMValues;
    xdsBestKeyKtoSkontoertragSatz2.AfterLoadDFMValues;
    xdsBestKeyKtoSkontoertragSatz3.AfterLoadDFMValues;
    xdsBestKeyKtoSkontoertragSatz4.AfterLoadDFMValues;
    xdsBestKeyKtoSkontoertragSatz5.AfterLoadDFMValues;
    xdsBestKeyKtoSkontoertragSatz6.AfterLoadDFMValues;
    xdsBestKeyKtoErloesschmaelerungenSatz1.AfterLoadDFMValues;
    xdsBestKeyKtoErloesschmaelerungenSatz2.AfterLoadDFMValues;
    xdsBestKeyKtoErloesschmaelerungenSatz3.AfterLoadDFMValues;
    xdsBestKeyKtoErloesschmaelerungenSatz4.AfterLoadDFMValues;
    xdsBestKeyKtoErloesschmaelerungenSatz5.AfterLoadDFMValues;
    xdsBestKeyKtoErloesschmaelerungenSatz6.AfterLoadDFMValues;
    xdsBestKeyNatura.AfterLoadDFMValues;
    xdsBestKeyBSchl_UST_Satz1.AfterLoadDFMValues;
    xdsBestKeyBSchl_UST_Satz2.AfterLoadDFMValues;
    xdsBestKeyBSchl_UST_Satz3.AfterLoadDFMValues;
    xdsBestKeyBSchl_UST_Satz4.AfterLoadDFMValues;
    xdsBestKeyBSchl_UST_Satz5.AfterLoadDFMValues;
    xdsBestKeyBSchl_UST_Satz6.AfterLoadDFMValues;
    xdsBestKeyBSchl_Vorsteuer_Satz1.AfterLoadDFMValues;
    xdsBestKeyBSchl_Vorsteuer_Satz2.AfterLoadDFMValues;
    xdsBestKeyBSchl_Vorsteuer_Satz3.AfterLoadDFMValues;
    xdsBestKeyBSchl_Vorsteuer_Satz4.AfterLoadDFMValues;
    xdsBestKeyBSchl_Vorsteuer_Satz5.AfterLoadDFMValues;
    xdsBestKeyBSchl_Vorsteuer_Satz6.AfterLoadDFMValues;
    xdsBestKeyDokTyp.AfterLoadDFMValues;
    sourceBestKey.AfterLoadDFMValues;
  end;
end;

end.